import React, { Component } from "react";

import { Menu, Segment, Sidebar,Popup } from "semantic-ui-react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import * as turf from '@turf/turf';
//import { CradleLoader } from 'react-loader-spinner';
//import { TailSpin } from "react-loader-spinner";
import "./DateCustom.css"
import 'leaflet/dist/leaflet.css';  // This is important for Leaflet's default styles



import {
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import TreeNode from "./TreeNodeV2";
import MapView from "./MapViewV2";
import menus from "../Helpers/menus";
import axios from 'axios'
import domain from "../../domain";
import colors from "../../colors";
import PickerPanel from 'rc-picker';
import 'rc-picker/assets/index.css';
import { FadeLoader } from "react-spinners";
//import Chart from "../../CChart_ET";
//import Charts from "./Recharts_et";
//import Charts from "./rechart_example";
import Charts from "./Echarts_et";
import TimeCharts from "./Echarts_Time"
//import Charts from "./echarts_example";


import { Rnd } from "react-rnd";
import { connect } from "react-redux";
import WBPopup from "./WBPopup";
import EBPopuup from "./EBPopup";
import pagecontent from "../Helpers/ETContent";
import AboutModal from "../../GeoportalModal";
//import { DateInput } from 'semantic-ui-calendar-react';
import { MonthInput,Input,DateInput } from "semantic-ui-calendar-react";
import { Icon } from "semantic-ui-react";
import { Form, Container } from 'semantic-ui-react';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import shp from 'shpjs';
import Draggable from 'react-draggable'; // Import Draggable component from 'react-draggable'





import "./LoadingAnimation.css"
import moment, { Moment } from 'moment'
import {
  modeChange,
  getETDates,

  setSelectedMNLayer,
  setSelectedFNLayer,

  onSlide,
  setSelectedMenu,
  setSelectedLayer,
  onClickSlideLeft,
  onClickSlideRight,
  handleDateChange,
  onMapClick,

  toggleVisibleGraphPanel,
  //toggleVisibleGraphPanel1,

  toggleSelectedNodeStatus,
  setLegend,
  sidebarToggle,
  technicalNodeToggle,
  disclaimerToggle,
  EBPToggle,
  handleDialogClose,

  getWidth
} from "../../redux_components/actions/ETActions";
library.add(
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight
);


class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
      india_states_boundary: null,
      productselected:"#",
      productselectedR:"#",

      modal: true,
      layerExist: true,
      tabs: menus.mapSideBar,
      collapsed:true,
      collapsed1:false,
      collapsed2:false,
      collapsed3:false,
      collapsed4:false,
      titleTimeseries:"#",
      availableDateAnalysis:[],
      showChart:true,
      x: (window.innerWidth-1200)/2,
      y: window.innerHeight - 650,
      width: 800,
      height:400,
      //x1: (window.innerWidth-270-300)/2,
     // y1: window.innerHeight - 500,
      //x2: (window.innerWidth-270-10)/2,
      //y2: window.innerHeight - 700,

      clickcount: 0,
      isDraggingAllowed:true,
      timestampselected:"#",
      timestampselectedR:"#",
      analysisselected:"#",
      administrativestateselected:"#",
      administrativedistrictselected:"#",
      basinselected:"#",
      customshapeselected:"#",
      analysisarealist:"#",
      districtlist:"#",
      timeseriesOperationselected:"#",
      boundary:null,
      analysistimeseriesdata:null,
      timeserieschartdata:null,
      timeserieschartdates:null,
      commandselected:"#",

      selectedMonthStart: "",
      selectedMonthEnd: "",
      selectedStrtMon:'#',
      selectedStrtYear:'#',
      selectedEndMon:'#',
      selectedEndYear:'#',
      selectedAnalysisForTimeseriesSpatial:"time",
      tablename:"#",
      analysisnameselected:"#",
      areaselected:"#",
      visualizeTimeChart:false,
      loadingTimeChart:false,
      isDraggable:false,

      buttonColor :"white",
      visibleGraphPanel1:false,
      compare_mn_yrMonths:[],
      compare_fn_selectedYear: "",
      compare_fn_yrMonths: [],
      compare_fn_selectedMonth: "",
      compare_fn_yrMonFN: [],
      compare_fn_selectedFN: null,
      compareLeftDate:null,
      compareleftDateForLayer:null,
      compareLeftWorkspace:null,
      compareLeftLayer:null,     
      visualizeLeftCompareFile:false,
      compareLeftButtonColor:"white",
      compareRightButtonColor:"white",

      compare_mn_selectedYear:null,
      compare_mn_selectedMonth:null,

      compareRightDate:null,
      compareRightDateForLayer:null,
      compareRightWorkspace:null,
      compareRightLayer:null,

      compare_mn_yrMonthsR:[],
      compare_fn_selectedYearR: null,
      compare_fn_yrMonthsR: [],
      compare_fn_selectedMonthR: null,
      compare_fn_yrMonFNR: [],
      compare_fn_selectedFNR: null,
      visualizeRightCompareFile:false,
      compareButtonColorR:"white",
      compare_mn_selectedYearR:null,
      compare_mn_selectedMonthR:null,
      //shapeFileData:null,
      shapefileData:null,
      shapefilegeom:null,
      drawGeojson:null,
      stopVisualisationLeft:true,
      stopVisualisationRight:true,
      AnalaysisminDate: null,
      AnalaysismaxDate: null,

      timeseries_y_axis:"AET (mm/day)",
      
    
      // basis_boundary:"#",
      // command_boundary:"#",
      // district_boundary:"#",
     // x: (window.innerWidth-800)/2,
      //y: window.innerHeight - 600,


      wms_url_base_layers: `${domain.Geoserver}geoserver/base-layers/wms`,
      wms_url_default: `${domain.Geoserver}geoserver/evapotranspiration/wms`,
    };
  }
  handleDragStop = (e, d) => {


    //consolee.log("draggable mode-----------",e,d)
    if (this.state.isDraggingAllowed) {
     
         // e.stopPropagation();
         
        // }}
     
    }
  }
  handleCompareLeftReset=()=>{
    this.setState({
      productselected:"#",
      timestampselected:"#",
      compareLeftDate:null,
      visualizeLeftCompareFile:false,
      compare_mn_selectedMonth:null,
      compare_mn_selectedYear:null,
      compare_fn_selectedFN:null,
      compare_fn_selectedMonth:null,
      compare_fn_selectedYear:null,
      stopVisualisationLeft:false,
      compareleftDateForLayer:null,
     compareLeftWorkspace:null,
      compareLeftLayer:null,  

    })
  }

  handleCompareRightReset=()=>{
    this.setState({
      productselectedR:"#",
      timestampselectedR:"#",
      compareRightDate:null,
      visualizeRightCompareFile:false,
      compare_mn_selectedMonthR:null,
      compare_mn_selectedYearR:null,
      compare_fn_selectedFNR:null,
      compare_fn_selectedMonthR:null,
      compare_fn_selectedYearR:null,
      stopVisualisationRight:false,
    compareRightDateForLayer:null,
   compareRightWorkspace:null,
compareRightLayer:null,  

    })
  }

  handleCompareLeftUpload=()=>{
  

    let workspace,layer,productname;
    const monthMap = { "January": "01", "February": "02", "March": "03", "April": "04", "May": "05", "June": "06", "July": "07", "August": "08", "September": "09", "October": "10", "November": "11", "December": "12" };

   // this.setState({visualizeLeftCompareFile:true,compareButtonColor:"grey"})
    if(this.state.timestampselected==="Daily")
    {
    if(this.state.productselected==="et"  &&  this.state.timestampselected==="Daily"  )
    {
        workspace="nhp_evapotranspiration"
        layer=workspace+":NHP_ISRO_AET_EB_DY_"+this.state.compareleftDateForLayer
    }
  
        //consolee.log("left compareeeee work layer ",workspace,layer)
    if(this.state.productselected!=="et" && this.state.timestampselected==="Daily" ){
      workspace="nhp_pet_evapotranspiration"
      layer="nhp_pet-evapotranspiration:PET_SNPP_R_EB_DY_"+this.state.compareleftDateForLayer
     }
    }

    if(this.state.timestampselected==="Monthly")
    {
      //consolee.log("monthlyyyyyyyyyyyydate",this.state.compare_mn_selectedYear,this.state.compare_mn_selectedMonth)
    if(this.state.productselected==="et" )
    {
        productname="AET"
        workspace="nhp_evapotranspiration"
        layer=workspace+":AET_SNPP_N_EB_MN_"+this.state.compare_mn_selectedYear+monthMap[this.state.compare_mn_selectedMonth]

    }
  
    if(this.state.productselected!=="et"  ){
      productname=this.state.productselected.split(" ")[0].toUpperCase()
      workspace=`nhp_${productname.toLowerCase()}_evapotranspiration`
      layer=`nhp_${productname.toLowerCase()}-evapotranspiration:${productname}_SNPP_N_EB_MN_`+this.state.compare_mn_selectedYear+monthMap[this.state.compare_mn_selectedMonth]
     }
    }

    if(this.state.timestampselected==="Fortnightly")
    {
            //consolee.log("fortnightlyyyyyyyyyyyydate",this.state.compare_fn_selectedFN,this.state.compare_fn_selectedMonth,this.state.compare_fn_selectedYear)

    if(this.state.productselected==="et" )
    {
         productname="AET"

        workspace="nhp_evapotranspiration"
        layer=workspace+":AET_SNPP_N_EB_"+this.state.compare_fn_selectedFN+"_"+this.state.compare_fn_selectedYear+monthMap[this.state.compare_fn_selectedMonth]
    } 
        //consolee.log("left compareeeee work layer ",workspace,layer)
        if(this.state.productselected!=="et"  ){
          productname=this.state.productselected.split(" ")[0].toUpperCase()
          workspace=`nhp_${productname.toLowerCase()}_evapotranspiration`
          layer=`nhp_${productname.toLowerCase()}-evapotranspiration:${productname}_SNPP_N_EB_`+this.state.compare_fn_selectedFN+"_"+this.state.compare_fn_selectedYear+monthMap[this.state.compare_fn_selectedMonth]
         }
    }
    this.setState({
      compareLeftWorkspace:workspace,
       compareLeftLayer:layer, 
     
        //visualizeLeftCompareFile:false,
        //compareLeftButtonColor:"white",

    
       
      //oment(e).format("DD-MM-YYYY")
     })
  }
  handleCompareRightUpload=()=>{
   
    let workspace,layer,productname;
    const monthMap = { "January": "01", "February": "02", "March": "03", "April": "04", "May": "05", "June": "06", "July": "07", "August": "08", "September": "09", "October": "10", "November": "11", "December": "12" };

   // this.setState({visualizeLeftCompareFile:true,compareButtonColor:"grey"})
    if(this.state.timestampselectedR==="Daily")
    {
    if(this.state.productselectedR==="et"  &&  this.state.timestampselectedR==="Daily"  )
    {
        workspace="nhp_evapotranspiration"
        layer=workspace+":NHP_ISRO_AET_EB_DY_"+this.state.compareRightDateForLayer
    }
  
        //consolee.log("left compareeeee work layer ",workspace,layer)
    if(this.state.productselectedR!=="et" && this.state.timestampselectedR==="Daily" ){
      workspace="nhp_pet_evapotranspiration"
      layer="nhp_pet-evapotranspiration:PET_SNPP_R_EB_DY_"+this.state.compareRightDateForLayer
     }
    }

    if(this.state.timestampselectedR==="Monthly")
    {
      //consolee.log("monthlyyyyyyyyyyyydate",this.state.compare_mn_selectedYearR,this.state.compare_mn_selectedMonthR)
    if(this.state.productselectedR==="et" )
    {
        productname="AET"
        workspace="nhp_evapotranspiration"
        layer=workspace+":AET_SNPP_N_EB_MN_"+this.state.compare_mn_selectedYearR+monthMap[this.state.compare_mn_selectedMonthR]

    }
  
    if(this.state.productselectedR!=="et"  ){
      productname=this.state.productselectedR.split(" ")[0].toUpperCase()
      workspace=`nhp_${productname.toLowerCase()}_evapotranspiration`
      layer=`nhp_${productname.toLowerCase()}-evapotranspiration:${productname}_SNPP_N_EB_MN_`+this.state.compare_mn_selectedYearR+monthMap[this.state.compare_mn_selectedMonthR]
     }
    }

    if(this.state.timestampselectedR==="Fortnightly")
    {
            //consolee.log("fortnightlyyyyyyyyyyyydaterightpanel",this.state.compare_fn_selectedFNR,this.state.compare_fn_selectedMonthR,this.state.compare_fn_selectedYearR)

    if(this.state.productselectedR==="et" )
    {
         productname="AET"

        workspace="nhp_evapotranspiration"
        layer=workspace+":AET_SNPP_N_EB_"+this.state.compare_fn_selectedFNR+"_"+this.state.compare_fn_selectedYearR+monthMap[this.state.compare_fn_selectedMonthR]
    } 
        //consolee.log("left compareeeee work layer ",workspace,layer)
        if(this.state.productselectedR!=="et"  ){
          productname=this.state.productselectedR.split(" ")[0].toUpperCase()
          workspace=`nhp_${productname.toLowerCase()}_evapotranspiration`
          layer=`nhp_${productname.toLowerCase()}-evapotranspiration:${productname}_SNPP_N_EB_`+this.state.compare_fn_selectedFNR+"_"+this.state.compare_fn_selectedYearR+monthMap[this.state.compare_fn_selectedMonthR]
         }
    }
    this.setState({
      compareRightWorkspace:workspace,
       compareRightLayer:layer, 
  
     })
  }
  handleDateChangeCompareLeft=(e)=>{

//consolee.log("left compare date---",new Date(e),this.props.selectedMenu,this.state.productselected,this.state.timestampselected)
let  compareLeftDate=e;
let layer,workspace,productsplit1,productsplit2;
if(compareLeftDate!==null)
{ 
  
  let mon=new Date(e).getMonth()+1
  let month = mon < 10 ? '0' + mon : mon.toString();

  let year=new Date(e).getFullYear()
  let days=new Date(e).getDate()
  let day = days < 10 ? '0' + days : days.toString();


  //consolee.log("left compareeeee",month,year,day)

this.setState({
 compareLeftDate:e,
 compareleftDateForLayer:year+month+day,
 compare_mn_selectedMonth:null,
 
compare_mn_selectedYear:null,
compare_fn_selectedFN:null,
compare_fn_selectedMonth:null,
compare_fn_selectedYear:null,
})
  }
}
handleDateChangeCompareRight=(e)=>{
  //consolee.log("left compare date---",new Date(e),this.props.selectedMenu,this.state.productselectedR,this.state.timestampselectedR)
  let  compareRightDate=e;
  let layer,workspace,productsplit1,productsplit2;
  if(compareRightDate!==null)
  { 
    
    let mon=new Date(e).getMonth()+1
    let month = mon < 10 ? '0' + mon : mon.toString();
  
    let year=new Date(e).getFullYear()
    let days=new Date(e).getDate()
    let day = days < 10 ? '0' + days : days.toString();
  
  
    //consolee.log("left compareeeee",month,year,day)
  
  this.setState({
   compareRightDate:e,
   compareRightDateForLayer:year+month+day,
   compare_mn_selectedMonthR:null,
 
    compare_mn_selectedYearR:null,
    compare_fn_selectedFNR:null,
    compare_fn_selectedMonthR:null,
    compare_fn_selectedYearR:null,
  })
    }
  }
  
  componentDidMount() {
    this.getIndiaStatesBoundary();
    this.props.getWidth();
    // //consolee.log(window.innerWidth);
    // if (window.innerWidth > 1000) {

    //   this.setState({
    //     visible:false
    //   });
    // }
  }

  toggleVisibleGraphPanel1 = () => {
    this.setState({
      visibleGraphPanel1: !this.state.visibleGraphPanel1,
    });
  };
  handleDateChangeRangeStart = (e) => {

    this.setState({ 
      selectedMonthStart:"",
      timeserieschartdata:null,
      visualizeTimeChart:true, 

      timeserieschartdates:null,
      visibleGraphPanel1:false,

   })

    //consolee.log("start changeeeeeeeeeeeeeee",new Date(e).getMonth() + 1)
    this.setState({ selectedMonthStart: e,
      visualizeTimeChart:false,
      buttonColor:"white",

      selectedStrtMon:new Date(e).getMonth() + 1,
      selectedStrtYear:new Date(e).getFullYear(),

   });

   //consolee.log("start change after set",this.state.selectedMonthStart)
  };

  handleDateChangeRangeEnd = (e,) => {
    this.setState({ 
      selectedMonthEnd:"" ,
      timeserieschartdata:null,
      timeserieschartdates:null,
      visibleGraphPanel1:false,

   })
    //consolee.log("start end change--",e)
  

    this.setState({ selectedMonthEnd:e,
      visualizeTimeChart:false,
      buttonColor:"white",

      selectedEndMon:new Date(e).getMonth() + 1,
    selectedEndYear: new Date(e).getFullYear()});
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.props.date !== prevProps.date) {
      this.props.setSelectedLayer(this.props.selectedMenu);
    }
  }
  updateTabs = (id) => {
    //consolee.log(id);
    let tabs = this.state.tabs;
    let newtabs = tabs.map((tab, index) => {
      if (tab.id === id) {
        if (tab.active === true) {
          tab.active = false;
        } else {
          tab.active = true;
        }
      } else {
        tab.active = false;
      }
      return tab;
    });
    //consolee.log(newtabs);
    return newtabs;
  };
  incrementCounter = () => {
    // this.setState((prevState) => {
    //     // Important: read `state` instead of `this.state` when updating.
    //     return {clickcount: Number(prevState.countcount) + 1}
    //   });
    this.setState({
      clickcount: this.state.clickcount + 1,
    });
  };
  handleTabClick = (id) => {
    this.setState({
      tabs: this.updateTabs(id),
      // visibleGraphPanel: false,
      // showInfo: false,
      // latlng: null
    });
  };
  setHandleDraggble=(value)=>{

  this.setState({
    isDraggingAllowed:value
  })
}
  getIndiaStatesBoundary = () => {

    //consolee.log("function call" )
    axios.post(`${domain.DBServer}/get-india-states-boundary`).then((result) => {
      if (result) {
        this.setState({
          india_states_boundary: result.data[0].india_boundary,
        });
      }
    });
  };

  // toggle = () => {
  //   this.setState({
  //     modal: !this.state.modal,

  //   });

  // };
  AnalysisForTimeseriesSpatialTool=(e)=>{
 this.setstate({
  selectedAnalysisForTimeseriesSpatial:e.target.value,
  timeserieschartdata:null,
  timeserieschartdates:null,
  visibleGraphPanel1:false,
 })
  }

  MapVisualization= ()=>{
    this.setState({
      collapsed:!(this.state.collapsed),
      india_states_boundary:null,
      drawGeojson:null,
      shapefilegeom:null,
      shapefileData:null,
      collapsed1:false,
      collapsed2:false,
      collapsed3:false,
      boundary:null,
      selectedMonthStart:"",

      selectedMonthEnd:"",
      

      collapsed4:false,
      timeserieschartdata:null,
      timeserieschartdates:null,
      visibleGraphPanel:false,
      visibleGraphPanel1:false,
      showChart:true,
   
    })
    this.getIndiaStatesBoundary()
    this.props.getWidth()

  }
  AnalysisTool=()=>{
    this.setState({ 
      productselected:"#",
      india_states_boundary:null,
      productselectedR:"#",
      areaselected:"#",
      drawGeojson:null,
      shapefilegeom:null,
      administrativedistrictselected:"#",
      administrativestateselected:"#",
      basinselected:"#",
      timeseriesOperationselected:"#",  
      timestampselectedR:"#",
      timestampselected:"#",
      customshapeselected:"#",
      collapsed1:!(this.state.collapsed1),
      analysisselected:"#",
      collapsed:false,
      collapsed2:false,
      collapsed3:false,
      visibleGraphPanel:false,
      visibleGraphPanel1:false,
      timeserieschartdata:null,
      timeserieschartdates:null,
      chartData:null,
      showChart:false,
      collapsed4:false,
      commandselected:"#",
      selectedMonthStart: "",
      selectedMonthEnd: "",
      boundary:null,
    })
    this.getIndiaStatesBoundary()
    this.props.getWidth()

  }
  TimeseriesTool=()=>{
    this.setState({
      productselected:"#",
      timestampselected:"#",
      collapsed2:!(this.state.collapsed2),
      collapsed:false,
      collapsed1:false,
      collapsed4:false,
      visibleGraphPanel:false,
      visibleGraphPanel1:false,
      timeserieschartdata:null,
      timeserieschartdates:null,
      showChart:false,
    })
  }

  SpatialTool=()=>{
    this.setState({
      collapsed3:!(this.state.collapsed3),
      collapsed:false,
      collapsed1:false,
      collapsed2:false,
      collapsed4:false,
      timeserieschartdata:null,
      timeserieschartdates:null,
      visibleGraphPanel:false,
      visibleGraphPanel1:false,
      showChart:false,

    })
  }
  ComparisonTool=()=>{
    this.setState({
      compareLeftWorkspace:null,
      compareLeftLayer:null,
      compareRightLayer:null,
      compareRightWorkspace:null,
      productselected:"#",
      productselectedR:"#",
      timestampselectedR:"#",
      timestampselected:"#",
      collapsed4:!(this.state.collapsed4),
      collapsed:false,
      collapsed1:false,
      collapsed2:false,
      collapsed3:false,
      timeserieschartdata:null,
      timeserieschartdates:null,
      visibleGraphPanel:false,
      visibleGraphPanel1:false,
      showChart:false,
      boundary:null,

    })
  }
  handleProductChange=(e)=>{
let productselected=e.target.value;

this.setState({

      //timestampselected:"#",
      india_states_boundary:null,
  
      areaselected:"#",
      drawGeojson:null,
      shapefilegeom:null,
      administrativedistrictselected:"#",
      administrativestateselected:"#",
      basinselected:"#",
      timeseriesOperationselected:"#",  
     // timestampselected:"#",
      customshapeselected:"#",
      analysisselected:"#",
      visibleGraphPanel:false,
      visibleGraphPanel1:false,
      timeserieschartdata:null,
      timeserieschartdates:null,
      chartData:null,
      
      commandselected:"#",
      selectedMonthStart: "",
      selectedMonthEnd: "",
 // compareLeftDate:null,
 stopVisualisationLeft:true,


})

//consolee.log("productttttttttttttttttttttt",productselected)
let yaxisname=this.state.timeseries_y_axis

if(productselected!=="#")
{ 
  if(productselected==="et"){
    yaxisname="AET (mm/day)"

  }
  if(productselected==="PET Evapotranspiration")
  {
    yaxisname="PET (mm/day)"

  }
  if(productselected==="ESI Evapotranspiration")
  {
    yaxisname="ESI"

  }
  if(productselected==="MAI Evapotranspiration"){
    yaxisname="MAI (%)"

  }

 


    this.setState({

        productselected:productselected,
        selectedMainMenu:productselected,
        timeserieschartdata:null,
        timeserieschartdates:null,
        visibleGraphPanel1:false,
        analysistimeseriesdata:null,
        visualizeTimeChart:false,
        buttonColor:"white",
        timeseries_y_axis:yaxisname,
        compareLeftDate:null,

       timestampselected:"#",

    })
}
  };

  
  handleProductChangeR=(e)=>{

    this.setState({
      //timestampselectedR:"#",
     // compareLeftDate:null,
     stopVisualisationRight:true,
    
    })
    let productselectedR=e.target.value;
    if(productselectedR!=="#")
    {
        this.setState({
            productselectedR:productselectedR,
             //selectedMainMenu:productselected,
            // analysistimeseriesdata:null,
            // visualizeTimeChart:false,
            // buttonColor:"white",
            compareRightDate:null,
    
        })
    }
      };
  handleTimestampChange=(e)=>
  {
    this.setState({
      compareLeftDate:null,
      timeserieschartdata:null,
      timeserieschartdates:null,
      visibleGraphPanel1:false,

    })
    let timestampselected=e.target.value
    let tablename;
    if(timestampselected!=="#")
    {
      let comparisonproductLeft ,productsplit1,productsplit2;
      if(this.state.productselected==="et" && timestampselected==="Daily" ){
     comparisonproductLeft="et-Evapotranspiration"
      }
      if(this.state.productselected==="et" && timestampselected!=="Daily" ){
        comparisonproductLeft="et-Evapotranspiration-"+timestampselected+"750"
        tablename="aet_Evapotranspiration_"+timestampselected+"750"
       }
       if(this.state.productselected!=="et" && timestampselected==="Daily" ){
        productsplit1=this.state.productselected.split(" ")[0].toLowerCase()
        productsplit2=this.state.productselected.split(" ")[1]
        

        comparisonproductLeft=productsplit1+"-"+productsplit2
         }
         if(this.state.productselected!="et" && timestampselected!=="Daily" ){
          productsplit1=this.state.productselected.split(" ")[0].toLowerCase()
          productsplit2=this.state.productselected.split(" ")[1]
           comparisonproductLeft=productsplit1+"-"+productsplit2+"-"+timestampselected+"750"
            tablename=productsplit1+"_"+productsplit2+"_"+timestampselected+"750"
          }

       this.props.setSelectedMenu(comparisonproductLeft)
       this.props.setSelectedLayer(comparisonproductLeft);


      //consolee.log(this.state.productselected,timestampselected,"product and timestamp")

      axios.get(`${domain.DBServer}/get-available-month-year/${tablename}`).then((result) => {
        if (result) {
          //consolee.log("All the dates along with months", result.data);
    
          // Initialize acc as an empty object before reducing
          const data = result.data.reduce((acc, { year, months }) => {
            const uniqueMonths = [...new Set(months.map(month => parseInt(month, 10) - 1))]; // Convert and remove duplicates
            acc[year] = uniqueMonths; // Convert to 0-indexed month
            return acc; // Important: return acc to accumulate properly
          }, {}); // Start with an empty object
          const years = Object.keys(data).map(Number);
          const minYear = Math.min(...years);
          const maxYear = Math.max(...years);
          this.setState({
            availableDateAnalysis: data, // Set state with the correctly accumulated data
            AnalaysisminDate:  new Date(minYear, 0, 1), // Start of the earliest available year
          
            AnalaysismaxDate: new Date(maxYear, 11, 31),
          });
          //consolee.log("All the dates along with monthdata s", data);

        }
      })
      .catch((error) => {
        //consolee.error("Error fetching available dates:", error);
      });
      this.setState({
        timestampselected:e.target.value,
        analysistimeseriesdata:null,
        visualizeTimeChart:false,
        buttonColor:"white",
        compareLeftDate:null,

      })
    }

  }
 
  getDayClassName = (date) => {
    const year = date.getFullYear().toString();
    const month = date.getMonth();
    return this.isAvailableDate(date) ? 'available-date' : 'disabled-date';
  };
  isAvailableMonthYear = (date) => {
    const year = date.getFullYear().toString(); // Convert year to string for comparison
    const month = date.getMonth(); // 0-indexed month
    const { availableDateAnalysis } = this.state;
    //consolee.log(`Checking year: ${year}, month: ${month}`);
    //consolee.log('Available months for this year:', availableDateAnalysis[year]);
    const isAvailable = availableDateAnalysis[year]?.includes(month) || false;
    //consolee.log(`wwwwwwwwwwwwYear: ${year}, Month: ${month}, Is Available: ${isAvailable}`);
    return isAvailable; // Check if the month is available in the state data
  };
  handleSaveGeoJSON = (geojsonData) => {
    //consolee.log("onsave eeeee",geojsonData)

    // Handle saving logic here, e.g., sending data to server
    //consolee.log("onsave GeoJSON data:", geojsonData);

    this.setState({

      drawGeojson:geojsonData,
      timeserieschartdata:null,
    })
  };

  handleTimestampChangeR=(e)=>
  {

    let timestampselectedR=e.target.value
    if(timestampselectedR!=="#")
    {
      let comparisonproductRight ,productsplit1,productsplit2;
      if(this.state.productselectedR==="et" && timestampselectedR==="Daily" ){
     comparisonproductRight="et-Evapotranspiration"
      }
      if(this.state.productselectedR==="et" && timestampselectedR!=="Daily" ){
        comparisonproductRight="et-Evapotranspiration-"+timestampselectedR+"750"
       }
       if(this.state.productselectedR!=="et" && timestampselectedR==="Daily" ){
        productsplit1=this.state.productselectedR.split(" ")[0].toLowerCase()
        productsplit2=this.state.productselectedR.split(" ")[1]
        

        comparisonproductRight=productsplit1+"-"+productsplit2
         }
         if(this.state.productselectedR!="et" && timestampselectedR!=="Daily" ){
          productsplit1=this.state.productselectedR.split(" ")[0].toLowerCase()
          productsplit2=this.state.productselectedR.split(" ")[1]
           comparisonproductRight=productsplit1+"-"+productsplit2+"-"+timestampselectedR+"750"
          }

       this.props.setSelectedMenu(comparisonproductRight)
       this.props.setSelectedLayer(comparisonproductRight);
        }
      this.setState({
        timestampselectedR:e.target.value,
        compareRightDate:null,
        // analysistimeseriesdata:null,
        // visualizeTimeChart:false,
        // buttonColor:"white",



      })

  }
  handleTimeseriesChartGen=()=>
  {
   //consolee.log("iam in the timeseries gen")
    let datavalues=[]  ,filename=[],date_list=[],dates=[],analysistimeseriesdata=[],title="#";
    let dates_final=[],values_final=[];
    let fn1values=[],fn2values=[];

    //consolee.log (":::::::",this.state.productselected, this.state.timestampselected ,this.state.shapefileData,this.state.drawGeojson ,this.state.analysisnameselected,this.state.areaselected,  this.state.selectedStrtMon , this.state.selectedEndMon ,this.state.selectedStrtYear,this.state.selectedEndYear ) 



    if (this.state.productselected ==="#" ){
      alert("Please select the Product.");
      return; // Exit the function early if required fields are missing
    }
      
    if (this.state.timestampselected  ==="#"){
      alert("Please select the Timestep.");
      return; // Exit the function early if required fields are missing
    } 


  if (this.state.selectedMonthStart > this.state.selectedMonthEnd) {
    alert("startDate should be before the endDate");
    return;
  } 
    
    if (this.state.selectedMonthStart ==="" ){
      alert("Please select the Start Date.");
      return; // Exit the function early if required fields are missing
    }
    if (this.state.selectedMonthEnd ==="" ){
      alert("Please select the End Date.");
      return; // Exit the function early if required fields are missing
    }
    
    if(this.state.analysisselected ==="#")
    
    {
      alert("Please select the Analaysis Type.");
      return; // Exit the function early if required fields are missing
    }

    if(this.state.analysisselected ==="administrate" && this.administrativestateselected==="#" )
    
    {
      alert("Please select the State.");
      return; // Exit the function early if required fields are missing
    }

    if(this.state.analysisselected ==="basin" && this.basinselected==="#" )
    
    {
      alert("Please select the Basin.");
      return; // Exit the function early if required fields are missing
    }
    if(this.state.analysisselected ==="commands" && this.commandselected==="#" )
    
    {
      alert("Please select the Command area.");
      return; // Exit the function early if required fields are missing
    }
    // if(this.state.analysisselected ==="Custom" && this.commandselected==="#" )
    
    // {
    //   alert("Please select the Command area.");
    //   return; // Exit the function early if required fields are missing
    // }
    
    if (
      this.state.shapefileData === null &&
      this.state.drawGeojson === null &&
      this.state.areaselected === "#"
    ) {
      alert("Please select the area.");
      return; // Exit the function early if required fields are missing
    }
     
    
     //consolee.log("ssssssssssssssss start date ",this.state.selectedMonthStart)

     //consolee.log("ssssssssssssssss end date ",this.state.selectedMonthEnd)


  
    try {
      //consolee.log("visualize onclick")
        this.setState({
          timeserieschartdata:null,
          timeserieschartdates:null,
          visualizeTimeChart:true, 
          visualizeLeftCompareFile:true,
          LoadingAnimation:true,
          buttonColor: 'grey'
     });
     let producttitle;

     let productname=this.state.productselected.replace(/\s/g, '_');

     if (productname==="et")
     {
       productname="aet_Evapotranspiration"
      

     }
     
     let timestamp=this.state.timestampselected
     let tablename = productname.toLowerCase() + '_' + timestamp.toLowerCase() + '750_tiled128';
//--------------------------------------------------
    //  if(tablename==='mai_evapotranspiration_fortnightly750')
    //  {
    //   tablename = 'mai_evapotranspiration_fortnightly750_tiled';
    //  }
      //let tablename = 'mai_evapotranspiration_fortnightly750_tiled';
//-------------------------------------------------------------------------------------------
     //consolee.log("tablenameeeeeeeeeeeeeeeestateee",tablename,timestamp,productname)
 


     //consolee.log("iam in the timeseri stamp",this.state.timestampselected)

     if (this.state.areaselected!=="#"&& this.state.customshapeselected==="#"){   

      //consolee.log("iam in the timeseries gen     area",this.state.timestampselected)

      axios.get(`${domain.DBServer}/get-et-${this.state.analysisnameselected}-stats/${this.state.areaselected}/${this.state.selectedStrtMon}/${this.state.selectedEndMon}/${this.state.selectedStrtYear}/${this.state.selectedEndYear}/${tablename}/${this.state.timeseriesOperationselected.toLowerCase()}`).then((result) => {
      if (result) {
        //consolee.log("resultttt of state stats",result.data)
       // this.setState({
        //  analysistimeseriesdata: result.data,
         // visualizeTimeChart:true,

      // });
       //consolee.log("product selectedddd",this.state.productselected)
       analysistimeseriesdata=result.data
      
      }
      // title=this.state.productselected +" - "+this.state.timeseriesOperationselected+ " Statistics for "+ this.state.areaselected 
      title=this.state.timestampselected+" "+this.state.timeseriesOperationselected+ " "+productname.split("_")[0].toUpperCase()+ " for " +this.state.areaselected 

       let temp=analysistimeseriesdata.sort()
        //consolee.log("this.setstate sorted ",temp)
       let timeserieschartdata= analysistimeseriesdata.map((item) =>{
        var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
        if(item.filename.includes('FN'))
        {
          const yearMonth = item.filename.match(regex)[0];
          
          const fortnight = item.filename.includes('FN1') ? 'FN1' : 'FN2';
          if(fortnight==="FN1")
          
          {
            //date_list.push(new Date(moment(yearMonth, 'YYYYMM').add(1, 'days').format()));

            //consolee.log("fortnight data fn1",yearMonth,fortnight)
            const fullDate = yearMonth + '01';
            const dateObject = moment(fullDate, 'YYYYMMDD').toDate();
            let formattedDate = moment(dateObject).format('DD MMM YYYY');

            const dayOfMonth = moment(dateObject).date();
            const fortnightPrefix = dayOfMonth <= 14 ? 'FN1' : 'FN2';
            formattedDate = formattedDate.replace(/^(\d+)/, fortnightPrefix);


          date_list.push(formattedDate)
          fn1values.push(item.stat)//.split(",")[1])

          }
          if(fortnight==="FN2")
          {
            //consolee.log("fortnight data fn2",yearMonth,fortnight)
          //date_list.push(new Date(moment(yearMonth, 'YYYYMM').add(14, 'days').format()));
          const fullDate = yearMonth + '15';
          const dateObject = moment(fullDate, 'YYYYMMDD').toDate();
          let formattedDate = moment(dateObject).format('DD MMM YYYY');
          const dayOfMonth = moment(dateObject).date();
          const fortnightPrefix = dayOfMonth <= 14 ? 'FN1' : 'FN2';
          formattedDate = formattedDate.replace(/^(\d+)/, fortnightPrefix);

            date_list.push(formattedDate)
          fn2values.push(item.stat)//.split(",")[1])
          }     
        }

        //consolee.log("fortnight data for FN111111111111111111111111:",date_list,datavalues)
          if(item.filename.includes('MN'))
          {
            //consolee.log("chart data from item",item)


            // date_list.push( new Date( moment(item.filename.match(regex)[0], "YYYYMM").format("MMM YYYY")))

            const dateObject = moment(item.filename.match(regex)[0], 'YYYYMM').toDate();
            const formattedDate = moment(dateObject).format('MMM YYYY');
            date_list.push(formattedDate)
              

            datavalues.push(item.stat)
            
          }      
               
       })
     
       if (this.state.timestampselected==="Fortnightly"){
       const sortByMonth = (a, b) => {
        const months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
        const monthA = months.indexOf(a.split(" ")[1].toLowerCase());
        const monthB = months.indexOf(b.split(" ")[1].toLowerCase());
        return monthA - monthB;
      };
      // Separate items into two arrays based on prefix
      const fn1Items = date_list.filter(date_list => date_list.startsWith("FN1"));
      const fn2Items = date_list.filter(date_list => date_list.startsWith("FN2"));
      //consolee.log("FN1 and FN2 dataaaaaaaaaaaaa ",fn1Items,"fn1values",fn1values,"fn2222222222222222222222222222dates2222",fn2Items,"fn2values",fn2values)
      let max_length = Math.max(fn1Items.length, fn2Items.length);

     // for (let i = 0; i < fn1Items.length; i++) {
      for (let i = 0; i < max_length; i++) {
        if (i < fn1Items.length) {
        dates_final.push(fn1Items[i]);

        values_final.push(fn1values[i]);
        }
        if (i < fn2Items.length) {
        dates_final.push(fn2Items[i]);

        values_final.push(fn2values[i]);
        }
      }

      const extractDate = (date) => {
        //consolee.log("DDDDDDDDDDDDDDDDates extract ",date)
        const [, month, year] = date.split(' ');
        return new Date(`${month} 1, ${year}`);
      }
      const dateObjects = dates_final.map(date => extractDate(date));
      const startDate = new Date(Math.min.apply(null, dateObjects));
      const endDate = new Date(Math.max.apply(null, dateObjects));
      //consolee.log("Resulting chart data with missing dates filled: yaxis",endDate)


      function getDatesInRange(startDate,endDate) {
        const dates = [];
        //consolee.log("Resulting chart data with missing dates filled: yaxis899")

        let currentDate = new Date(startDate);
        while (currentDate <= endDate) {
          dates.push(new Date(currentDate));
          currentDate.setMonth(currentDate.getMonth() + 1); // Move to the next month
        }
        return dates;
      }

      const allDatesInRange = getDatesInRange(startDate, endDate);
      const formattedDates = allDatesInRange.flatMap(date => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthYear = monthNames[date.getMonth()] + ' ' + date.getFullYear();
        return [
            'FN1 ' + monthYear,
            'FN2 ' + monthYear
        ];
    });
    //consolee.log("formatted dates", formattedDates,dates_final.length,values_final.length,formattedDates.length)
      
      // Initialize an empty chartData array
      let dates_final1=[],values_final1=[];
      for (let j = 0; j < formattedDates.length; j++) {
        //consolee.log("formatted ew", formattedDates[j], dates_final[j]);
        if (dates_final.includes(formattedDates[j])) {
          let index = dates_final.indexOf(formattedDates[j]);
          dates_final1.push(dates_final[index]);
          values_final1.push(values_final[index]);
        } else {
          dates_final1.push(formattedDates[j]);
          values_final1.push("NA");
        }
      }    
      // Iterate over formattedDates and add missing dates to chartData with null values

      //consolee.log("formatted datesnewifffff", formattedDates,values_final1,dates_final1.length,values_final1.length,formattedDates.length)
 
      this.setState({
        timeserieschartdates:dates_final1,
        timeserieschartdata:values_final1,
      })
    }
    else{
      this.setState({
      timeserieschartdates:date_list,
      timeserieschartdata:datavalues,
      })
      //consolee.log("formatted datesnewelseeeeeee",date_list,datavalues)
    }
      //consolee.log("datavaluessssssssschart",this.state.timestampselected,date_list,datavalues,this.state.timeserieschartdates,this.state.timeserieschartdata)
      dates=date_list.sort((a, b) => b.timestamp - a.timestamp);
   
       
        this.setState({
          titleTimeseries:title,
          visibleGraphPanel1:true,
          visualizeTimeChart:false,
          buttonColor: 'white'
        
        })
   
      
    });
   }

   if(this.state.shapefileData===null && this.state.customshapeselected==="upload"){
    window.alert('upload the shape file');
   }
    else if (this.state.shapefileData!==null && this.state.customshapeselected==="upload")
    {   

    //consolee.log("iam in the timeseries gen   shapefile")

    const jsonString = JSON.stringify(this.state.shapefilegeom);

    // Check the size of the JSON string in bytes
    const bytes = new Blob([jsonString]).size;

    // Define the maximum allowed size in bytes
    const maxSizeBytes = 2*1024 * 1024; // 1MB (adjust as need)
    if (bytes > maxSizeBytes) {
      window.alert('File size exceeds the maximum allowed size.'); // Show alert to the user
    } 
    else 
    {
      // Convert geometry data to Blob
     // Parse the JSON string
     const data = JSON.parse(jsonString);
     //consolee.log("Parsed Dataaaaaaaaaaaaa:", data);
     // Extracting type and coordinates for MultiPolygon
      const type = data[0].type;
      const coordinates_temp = data.map(item => item.coordinates);
      const coordinates=coordinates_temp[0]
      //consolee.log("Type:", type);
      //consolee.log("Coordinates:", coordinates[0]);
          // Extract the type and coordinates:
     
     // Create a new object with type and coordinates
     const newData = { type, coordinates};
     //consolee.log("dataaaaaaaaaaaaaa'",newData)
     
     // Convert the new object back to JSON
     const newJsonString = JSON.stringify(newData);
     
     // Create a Blob from the new JSON string
     const blob = new Blob([newJsonString], { type: 'application/json' });
     
     // Create a File from the Blob
     const file = new File([blob], 'shapefile.json', { type: 'application/json' });
     
     // Construct FormData object and append the file
     const formData = new FormData();
     formData.append('file', file);
     
     //consolee.log("newDataaaaaaaaaaaa", newData);
     

      //consolee.log("newDataaaaaaaaaaaa",newData)
      // Other request data
      const requestData = {
          selectedStrtMon: this.state.selectedStrtMon,
          selectedEndMon: this.state.selectedEndMon,
          selectedStrtYear: this.state.selectedStrtYear,
          selectedEndYear: this.state.selectedEndYear,
          tablename: tablename,
          timeseriesOperationselected: this.state.timeseriesOperationselected.toLowerCase()
      };
  
      // Append other request data to FormData object
      Object.entries(requestData).forEach(([key, value]) => {
          formData.append(key, value);
      });
  
      // Make Axios POST request
      axios.post(`${domain.DBServer}/get-et-shapefile-stats`, formData, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }).then(response => {
        if (response) {
          //consolee.log("resultttt of state stats",response.data)
   
         //consolee.log("product selectedddd",this.state.productselected)
         analysistimeseriesdata=response.data
        
        }
        //title=this.state.timeseriesOperationselected+" "+this.state.timeseriesOperationselected+ " of "+this.state.productselected+ " for " this.state.areaselected 

        title=this.state.timestampselected+" "+this.state.timeseriesOperationselected+ " of "+productname.split("_")[0].toUpperCase() 
        let temp=analysistimeseriesdata.sort()
        //consolee.log("this.setstate sorted ",temp)
       let timeserieschartdata= analysistimeseriesdata.map((item) =>{
        var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
        if(item.filename.includes('FN'))
        {
          const yearMonth = item.filename.match(regex)[0];
          const fortnight = item.filename.includes('FN1') ? 'FN1' : 'FN2';
         
          if(fortnight==="FN1")
          
          {
            //date_list.push(new Date(moment(yearMonth, 'YYYYMM').add(1, 'days').format()));

            //consolee.log("fortnight data fn1",yearMonth,fortnight)
            const fullDate = yearMonth + '01';
            const dateObject = moment(fullDate, 'YYYYMMDD').toDate();
            let formattedDate = moment(dateObject).format('DD MMM YYYY');

            const dayOfMonth = moment(dateObject).date();
            const fortnightPrefix = dayOfMonth <= 14 ? 'FN1' : 'FN2';
            formattedDate = formattedDate.replace(/^(\d+)/, fortnightPrefix);


          date_list.push(formattedDate)
          fn1values.push(item.stat)//.split(",")[1])

          }
          if(fortnight==="FN2")
          {
            //consolee.log("fortnight data fn2",yearMonth,fortnight)
          //date_list.push(new Date(moment(yearMonth, 'YYYYMM').add(14, 'days').format()));
          const fullDate = yearMonth + '15';
          const dateObject = moment(fullDate, 'YYYYMMDD').toDate();
          let formattedDate = moment(dateObject).format('DD MMM YYYY');
          const dayOfMonth = moment(dateObject).date();
          const fortnightPrefix = dayOfMonth <= 14 ? 'FN1' : 'FN2';
          formattedDate = formattedDate.replace(/^(\d+)/, fortnightPrefix);

            date_list.push(formattedDate)
          fn2values.push(item.stat)//.split(",")[1])
          }     
        }

        //consolee.log("fortnight data for FN111111111111111111111111:",date_list,datavalues)
          if(item.filename.includes('MN'))
          {
            //consolee.log("chart data from item",item)


            // date_list.push( new Date( moment(item.filename.match(regex)[0], "YYYYMM").format("MMM YYYY")))

            const dateObject = moment(item.filename.match(regex)[0], 'YYYYMM').toDate();
            const formattedDate = moment(dateObject).format('MMM YYYY');
            date_list.push(formattedDate)
              

            datavalues.push(item.stat)
            
          }      
               
       })
     
       if (this.state.timestampselected==="Fortnightly"){
       const sortByMonth = (a, b) => {
        const months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
        const monthA = months.indexOf(a.split(" ")[1].toLowerCase());
        const monthB = months.indexOf(b.split(" ")[1].toLowerCase());
        return monthA - monthB;
      };
      // Separate items into two arrays based on prefix
      const fn1Items = date_list.filter(date_list => date_list.startsWith("FN1"));
      const fn2Items = date_list.filter(date_list => date_list.startsWith("FN2"));
      //consolee.log("FN1 and FN2 dataaaaaaaaaaaaa ",fn1Items,"fn1values",fn1values,"fn2222222222222222222222222222dates2222",fn2Items,"fn2values",fn2values)
      
      let max_length = Math.max(fn1Items.length, fn2Items.length);

     // for (let i = 0; i < fn1Items.length; i++) {
      for (let i = 0; i < max_length; i++) {
        if (i < fn1Items.length) {
        dates_final.push(fn1Items[i]);

        values_final.push(fn1values[i]);
        }
        if (i < fn2Items.length) {
        dates_final.push(fn2Items[i]);

        values_final.push(fn2values[i]);
        }
      }

      const extractDate = (date) => {
        //consolee.log("DDDDDDDDDDDDDDDDates extract ",date)
        const [, month, year] = date.split(' ');
        return new Date(`${month} 1, ${year}`);
      }
      const dateObjects = dates_final.map(date => extractDate(date));
      const startDate = new Date(Math.min.apply(null, dateObjects));
      const endDate = new Date(Math.max.apply(null, dateObjects));
      //consolee.log("Resulting chart data with missing dates filled: yaxis",endDate)


      function getDatesInRange(startDate,endDate) {
        const dates = [];
        //consolee.log("Resulting chart data with missing dates filled: yaxis899")

        let currentDate = new Date(startDate);
        while (currentDate <= endDate) {
          dates.push(new Date(currentDate));
          currentDate.setMonth(currentDate.getMonth() + 1); // Move to the next month
        }
        return dates;
      }

      const allDatesInRange = getDatesInRange(startDate, endDate);
      const formattedDates = allDatesInRange.flatMap(date => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthYear = monthNames[date.getMonth()] + ' ' + date.getFullYear();
        return [
            'FN1 ' + monthYear,
            'FN2 ' + monthYear
        ];
    });
    //consolee.log("formatted dates", formattedDates,dates_final.length,values_final.length,formattedDates.length)
      
      // Initialize an empty chartData array
      let dates_final1=[],values_final1=[];
      for (let j = 0; j < formattedDates.length; j++) {
        //consolee.log("formatted ew", formattedDates[j], dates_final[j]);
        if (dates_final.includes(formattedDates[j])) {
          let index = dates_final.indexOf(formattedDates[j]);
          dates_final1.push(dates_final[index]);
          values_final1.push(values_final[index]);
        } else {
          dates_final1.push(formattedDates[j]);
          values_final1.push("NA");
        }
      }    
      // Iterate over formattedDates and add missing dates to chartData with null values

      //consolee.log("formatted datesnew", formattedDates,dates_final1.length,values_final1.length,formattedDates.length)
 

      this.setState({
        timeserieschartdates:dates_final1,
        timeserieschartdata:values_final1,

      })
    }
    else{
      this.setState({
      timeserieschartdates:date_list,
      timeserieschartdata:datavalues,

      })
    }
      //consolee.log("datavaluessssssssssssssssssss",datavalues,dates)
      dates=date_list.sort((a, b) => b.timestamp - a.timestamp);
   
       
        this.setState({
          titleTimeseries:title,
          visibleGraphPanel1:true,
          visualizeTimeChart:false,
          buttonColor: 'white'
        
        })

         })
        .catch(error => {
          //consolee.error('Error fetching data:', error);
        });
    }
  }


  if (this.state.drawGeojson!==null && this.state.customshapeselected==="draw")

  {   
    
  //consolee.log("iam in the timeseries gen draw",this.state.drawGeojson)

  const jsonString = JSON.stringify(this.state.drawGeojson);

  // Check the size of the JSON string in bytes
  const bytes = new Blob([jsonString]).size;
  //consolee.log("bytes",bytes)

  // Define the maximum allowed size in bytes
  const maxSizeBytes = 2*1024 * 1024; // 1MB (adjust as need)
  if (bytes > maxSizeBytes) {
    window.alert('File size exceeds the maximum allowed size.'); // Show alert to the user
  } 
  else 
  {
    // Convert geometry data to Blob
   // Parse the JSON string
   const data = JSON.parse(jsonString);
   //consolee.log("Parsed Dataaaaaaaaaaaaa:", data);
   // Extracting type and coordinates for MultiPolygon
   const type = data.features[0].geometry.type;
   //consolee.log("Geometry Type:", type);
   
   // Access the coordinates of the first feature
   const coordinates = data.features[0].geometry.coordinates;
   //consolee.log("Coordinates:", coordinates);
   
        // Extract the type and coordinates:
   
   // Create a new object with type and coordinates
   const newData = { type, coordinates};
   //consolee.log("dataaaaaaaaaaaaaa'",newData)
   
   // Convert the new object back to JSON
   const newJsonString = JSON.stringify(newData);
   
   // Create a Blob from the new JSON string
   const blob = new Blob([newJsonString], { type: 'application/json' });
   
   // Create a File from the Blob
   const file = new File([blob], 'shapefile.json', { type: 'application/json' });
   
   // Construct FormData object and append the file
   const formData = new FormData();
   formData.append('file', file);
   
   //consolee.log("newDataaaaaaaaaaaa", newData);
   

    //consolee.log("newDataaaaaaaaaaaa",newData)
    // Other request data
    const requestData = {
        selectedStrtMon: this.state.selectedStrtMon,
        selectedEndMon: this.state.selectedEndMon,
        selectedStrtYear: this.state.selectedStrtYear,
        selectedEndYear: this.state.selectedEndYear,
        tablename: tablename,
        timeseriesOperationselected: this.state.timeseriesOperationselected.toLowerCase()
    };

    // Append other request data to FormData object
    Object.entries(requestData).forEach(([key, value]) => {
        formData.append(key, value);
    });

    // Make Axios POST request
    axios.post(`${domain.DBServer}/get-et-shapefile-stats`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then(response => {
      if (response) {
        //consolee.log("resultttt of state stats",response.data)
 
       //consolee.log("product selectedddd",this.state.productselected)
       analysistimeseriesdata=response.data
      
      }

      
      title=this.state.timestampselected+" "+this.state.timeseriesOperationselected+ " of "+productname.split("_")[0].toUpperCase() 
     let temp=analysistimeseriesdata.sort()
      //consolee.log("this.setstate sorted ",temp)
     let timeserieschartdata= analysistimeseriesdata.map((item) =>{
      var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
      if(item.filename.includes('FN'))
      {
        const yearMonth = item.filename.match(regex)[0];
        
        const fortnight = item.filename.includes('FN1') ? 'FN1' : 'FN2';
        if(fortnight==="FN1")
        
        {
          //date_list.push(new Date(moment(yearMonth, 'YYYYMM').add(1, 'days').format()));

          //consolee.log("fortnight data fn1",yearMonth,fortnight)
          const fullDate = yearMonth + '01';
          const dateObject = moment(fullDate, 'YYYYMMDD').toDate();
          let formattedDate = moment(dateObject).format('DD MMM YYYY');

          const dayOfMonth = moment(dateObject).date();
          const fortnightPrefix = dayOfMonth <= 14 ? 'FN1' : 'FN2';
          formattedDate = formattedDate.replace(/^(\d+)/, fortnightPrefix);


        date_list.push(formattedDate)
        fn1values.push(item.stat)//.split(",")[1])

        }
        if(fortnight==="FN2")
        {
          //consolee.log("fortnight data fn2",yearMonth,fortnight)
        //date_list.push(new Date(moment(yearMonth, 'YYYYMM').add(14, 'days').format()));
        const fullDate = yearMonth + '15';
        const dateObject = moment(fullDate, 'YYYYMMDD').toDate();
        let formattedDate = moment(dateObject).format('DD MMM YYYY');
        const dayOfMonth = moment(dateObject).date();
        const fortnightPrefix = dayOfMonth <= 14 ? 'FN1' : 'FN2';
        formattedDate = formattedDate.replace(/^(\d+)/, fortnightPrefix);

          date_list.push(formattedDate)
        fn2values.push(item.stat)//.split(",")[1])
        }     
      }

      //consolee.log("fortnight data for FN111111111111111111111111:",date_list,datavalues)
        if(item.filename.includes('MN'))
        {
          //consolee.log("chart data from item",item)


          // date_list.push( new Date( moment(item.filename.match(regex)[0], "YYYYMM").format("MMM YYYY")))

          const dateObject = moment(item.filename.match(regex)[0], 'YYYYMM').toDate();
          const formattedDate = moment(dateObject).format('MMM YYYY');
          date_list.push(formattedDate)
            

          datavalues.push(item.stat)
          
        }      
             
     })
   
     if (this.state.timestampselected==="Fortnightly"){
     const sortByMonth = (a, b) => {
      const months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
      const monthA = months.indexOf(a.split(" ")[1].toLowerCase());
      const monthB = months.indexOf(b.split(" ")[1].toLowerCase());
      return monthA - monthB;
    };
    // Separate items into two arrays based on prefix
    const fn1Items = date_list.filter(date_list => date_list.startsWith("FN1"));
    const fn2Items = date_list.filter(date_list => date_list.startsWith("FN2"));
    //consolee.log("FN1 and FN2 dataaaaaaaaaaaaa ",fn1Items,"fn1values",fn1values,"fn2222222222222222222222222222dates2222",fn2Items,"fn2values",fn2values)
    let max_length = Math.max(fn1Items.length, fn2Items.length);

    // for (let i = 0; i < fn1Items.length; i++) {
     for (let i = 0; i < max_length; i++) {
       if (i < fn1Items.length) {
       dates_final.push(fn1Items[i]);

       values_final.push(fn1values[i]);
       }
       if (i < fn2Items.length) {
       dates_final.push(fn2Items[i]);

       values_final.push(fn2values[i]);
       }
     }

     const extractDate = (date) => {
       //consolee.log("DDDDDDDDDDDDDDDDates extract ",date)
       const [, month, year] = date.split(' ');
       return new Date(`${month} 1, ${year}`);
     }
     const dateObjects = dates_final.map(date => extractDate(date));
     const startDate = new Date(Math.min.apply(null, dateObjects));
     const endDate = new Date(Math.max.apply(null, dateObjects));
     //consolee.log("Resulting chart data with missing dates filled: yaxis",endDate)


     function getDatesInRange(startDate,endDate) {
       const dates = [];
       //consolee.log("Resulting chart data with missing dates filled: yaxis899")

       let currentDate = new Date(startDate);
       while (currentDate <= endDate) {
         dates.push(new Date(currentDate));
         currentDate.setMonth(currentDate.getMonth() + 1); // Move to the next month
       }
       return dates;
     }

     const allDatesInRange = getDatesInRange(startDate, endDate);
     const formattedDates = allDatesInRange.flatMap(date => {
       const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
       const monthYear = monthNames[date.getMonth()] + ' ' + date.getFullYear();
       return [
           'FN1 ' + monthYear,
           'FN2 ' + monthYear
       ];
   });
   //consolee.log("formatted dates", formattedDates,dates_final.length,values_final.length,formattedDates.length)
     
     // Initialize an empty chartData array
     let dates_final1=[],values_final1=[];
     for (let j = 0; j < formattedDates.length; j++) {
       //consolee.log("formatted ew", formattedDates[j], dates_final[j]);
       if (dates_final.includes(formattedDates[j])) {
         let index = dates_final.indexOf(formattedDates[j]);
         dates_final1.push(dates_final[index]);
         values_final1.push(values_final[index]);
       } else {
         dates_final1.push(formattedDates[j]);
         values_final1.push("NA");
       }
     }    
     // Iterate over formattedDates and add missing dates to chartData with null values

     //consolee.log("formatted datesnew", formattedDates,dates_final1.length,values_final1.length,formattedDates.length)

     this.setState({
       timeserieschartdates:dates_final1,
       timeserieschartdata:values_final1,

     })
  }
  else{
    this.setState({
    timeserieschartdates:date_list,
    timeserieschartdata:datavalues,

    })
  }
    //consolee.log("datavaluessssssssssssssssssss",datavalues,dates)
    dates=date_list.sort((a, b) => b.timestamp - a.timestamp);
 
     
      this.setState({
        titleTimeseries:title,
        visibleGraphPanel1:true,
        visualizeTimeChart:false,
        buttonColor: 'white'
      
      })

       })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }
}
    }
    catch (error) {
     
      console.error('Error ', error);
   

    }
    setTimeout(() => {
      // After completion, clear the loading timeout
      clearTimeout(this.loadingTimeout);
      // Reset isLoading state
      this.setState({ LoadingAnimation: false });
    }, 2000);

//consolee.log("lastttttttttttttttttttttttttttttttt")
  }
    handleAnalaysisChange=(e)=>
  
    {
      
      this.setState({
        analysisselected:"#",
        timeserieschartdata:null,
        timeserieschartdates:null,
        visibleGraphPanel1:false,
        drawGeojson:null,
        shapefilegeom:null,
        boundary:null,
        commandselected:'#',
        basinselected:"#",
        administrativedistrictselected:"#",
        administrativestateselected:"#",
        shapefilegeom:null,
        analysisarealist:"#",
        customshapeselected:"#",
        areaselected:"#",
       
        

      })
     
    if(e.target.value!=="#" && e.target.value!=="Custom" )
    {
    let analysisselected=e.target.value

    axios.get(`${domain.DBServer}/get-et-${analysisselected}`).then((result) => {
      if (result) {
        //consolee.log("analysisarealist",result.data)
        this.setState({
         analysisarealist: result.data,
         analysistimeseriesdata:null,
         collapsed2:false,
        
         
          // boundary: result.data[0].himalayan_boundary,
          loading: true,
        });
      }
    });
    }

    //consolee.log("e.target.value",e.target.value)

      this.setState({
        analysisselected:e.target.value

      })
     

    }
  handleAdministrativeStateChange=(e)=>
  {
   
    this.setState({
      administrativestateselected:e.target.value,

      analysisnameselected:"state",
      timeserieschartdata:null,
      timeserieschartdates:null,
      visibleGraphPanel1:false,
      //tablename:tablename,
      areaselected:e.target.value,
      visualizeTimeChart:false,
      buttonColor:"white",
      drawGeojson:null,
      shapefilegeom:null,
      customshapeselected:"#",

    })


    axios.get(`${domain.DBServer}/get-et-admindistrict/${e.target.value}`).then((result) => {
      if (result) {
        //consolee.log("analysisarealisttttt",result.data)
        this.setState({
         districtlist: result.data,
         boundary:null,

          // boundary: result.data[0].himalayan_boundary,
          loading: true,
        });
      }
    });
    axios.post(`${domain.DBServer}/get-et-state-boundary/${e.target.value}`).then((result) => {
      if (result) {
        if(result.data[0].boundary.length!==0){
          this.setState({
            boundary: result.data[0].boundary,
          });
        }
        
      }
    });
    // axios.get(`${domain.DBServer}/get-et-state-stats/${e.target.value}/${this.state.selectedStrtMon}/${this.state.selectedEndMon}/${this.state.selectedStrtYear}/${this.state.selectedEndYear}/${tablename}`).then((result) => {
    //   if (result) {
    //     console.log("resultttt of state stats",result.data)
    //     this.setState({
    //       analysistimeseriesdata: result.data,
    //    });
    //   }
    // });

   

  }


  handleAdministrativeDistrictChange=(e)=>
   
  {
    if (e.target.value!=="#")
      {

    axios.post(`${domain.DBServer}/get-et-district-boundary/${this.state.administrativestateselected}/${e.target.value}`).then((result) => {
      if (result) {
        this.setState({
          boundary: result.data[0].boundary,
          customshapeselected:"#",
          timeserieschartdata:null,
          timeserieschartdates:null,
          visibleGraphPanel1:false,
          visualizeTimeChart:false,
          buttonColor:"white",
          drawGeojson:null,
          shapefilegeom:null,

        });
      }
    });
    // let productname=this.state.productselected.replace(/\s/g, '_');

    // if (productname==="et")
    // {
    //   productname="aet_Evapotranspiration"
    // }
    // let timestamp=this.state.timestampselected
    // let tablename = productname.toLowerCase() + '_' + timestamp.toLowerCase() + '750';

    this.setState({
      administrativedistrictselected:e.target.value,

    
         analysisnameselected:"district",
        // tablename:tablename,
         areaselected:e.target.value,
  
    })
    //console.log("tablenameeeeeeeeeeeeeeeeedistricte",tablename,timestamp,productname)

    // axios.get(`${domain.DBServer}/get-et-district-stats/${e.target.value}/${this.state.selectedStrtMon}/${this.state.selectedEndMon}/${this.state.selectedStrtYear}/${this.state.selectedEndYear}/${tablename}`).then((result) => {
    //   if (result) {
    //     console.log("resultttt of disrtict stats",result.data)
    //     this.setState({
    //       analysistimeseriesdata: result.data,
    //    });
    //   }
    // });
}
if(e.target.value==="#"){
  this.setState({
    administrativedistrictselected:e.target.value
  })

  axios.post(`${domain.DBServer}/get-et-state-boundary/${this.state.administrativestateselected}`).then((result) => {
    if (result) {
      if(result.data[0].boundary.length!==0){
        this.setState({
          boundary: result.data[0].boundary,
          administrativedistrictselected:"#",
          customshapeselected:"#",
          areaselected:this.state.administrativestateselected,
          analysisnameselected:"state",
        });
      }
      
    }
  });

}
  }
  compare_mn_getMonthsR = (e) => {
    // let mn_yrMonths = [];

    let find1 = this.props.monthly_dates.filter((item) => (item.year === e))
    
    //consolee.log('MOnts', this.props.monthly_dates)
    //consolee.log('Find', find1)

    this.setState({
      compare_mn_yrMonthsR: find1,
  
   

    })
  }
  compare_mn_YearChangeR = (e) => {
    if (e.target.value !== '#') {
      this.compare_mn_getMonthsR(e.target.value)
      this.setState({
        compare_mn_selectedYearR: e.target.value,
        compare_fn_selectedFNR:null,
        compare_fn_selectedMonthR:null,
        compare_fn_selectedYearR:null,
        compareRightDate:null,

      })
    }
  }
  compare_fn_YearChangeR= (e) => {

    this.props.setSelectedFNLayer("", "")

    if (e.target.value !== '#') {
      this.compare_fn_getMonthsR(e.target.value)
      this.setState({
        compare_fn_selectedYearR: e.target.value,
        compare_mn_selectedYearR:null,
        compare_mn_selectedMonthR:null,
        compareRightDate:null,
      })
    }
  }

  compare_fn_MonthChangeR = (e) => {
    this.props.setSelectedFNLayer("", "")
    
    if (e.target.value !== '#') {
      this.setState({
        compare_fn_selectedMonthR: e.target.value,
        compare_mn_selectedYearR:null,
        compare_mn_selectedMonthR:null,
        compareRightDate:null,
      })
      this.compare_fn_getFNR(e.target.value)
    }
  }

  compare_fn_getFNR = (e) => {
    //consolee.log('E', e)
    //consolee.log('MOnts', this.props.fortnightly_dates)

    let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.compare_fn_selectedYearR && item.month === e))

    //consolee.log('Find', find1)

    this.setState({
      compare_fn_yrMonFNR: find1,
   
    })
  }



  compare_fn_getMonthsR = (e) => {
    // let mn_yrMonths = [];
    let months = new Set();

    let find1 = this.props.fortnightly_dates.filter((item) => (item.year === e))

    find1.map((item) => {
      months.add(item.month);
    });
    
    //consolee.log('MOnts', this.props.fortnightly_dates)
    //consolee.log('Find', find1)

    this.setState({
      compare_fn_yrMonthsR: Array.from(months)
    })
  }
  compare_mn_MonthChangeR = (e) => {
    if (e.target.value !== '#') {
      // this.mn_getMonths(e.target.value)
      this.setState({
        compare_mn_selectedMonthR: e.target.value,
        compare_fn_selectedFNR:null,
        compare_fn_selectedMonthR:null,
        compare_fn_selectedYearR:null,
        compareRightDate:null,
      })
    }
  }

  compare_FNChangeR = (e) => {
    if (e.target.value !== '#') {
      // this.mn_getMonths(e.target.value)

      
      this.setState({
        compare_fn_selectedFNR: e.target.value,
       compare_mn_selectedYearR:null,
       compare_mn_selectedMonthR:null,
        compareRightDate:null,
      })
      if(this.props.selectedMenu==="et-Evapotranspiration-Fortnightly750")
      {
        //consolee.log("selected product in if ",this.props.selectedMenu)
        let product="AET"
        this.setState({
          product:product

        }) 
        let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.compare_fn_selectedYearR && item.month === this.state.compare_fn_selectedMonthR && item.fortnight === e.target.value));

      this.props.setSelectedFNLayer(find1[0].layerdate, find1[0].fortnight,product)
        //consolee.log("selected product from product:",this.props.productselected)
      }

      if(this.props.selectedMenu!=="et-Evapotranspiration-Fortnightly750")
      {
        //consolee.log("selected product elseif",this.props.selectedMenu)
        let product=(this.props.selectedMenu).split("-")[0].toUpperCase()
        this.setState({
          product:product

        }) 
        let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.compare_fn_selectedYearR && item.month === this.state.compare_fn_selectedMonthR && item.fortnight === e.target.value));

      this.props.setSelectedFNLayer(find1[0].layerdate, find1[0].fortnight,product)
        //consolee.log("selected product from product:",this.props.productselected)
      }
      
    }
  }
  //-----------------------------------------------------------------
  compare_mn_getMonths = (e) => {
    // let mn_yrMonths = [];

    let find1 = this.props.monthly_dates.filter((item) => (item.year === e))
    
    //consolee.log('MOnts', this.props.monthly_dates)
    //consolee.log('Find', find1)

    this.setState({
      compare_mn_yrMonths: find1
    })
  }
  compare_mn_YearChange = (e) => {
    if (e.target.value !== '#') {
      this.compare_mn_getMonths(e.target.value)
      this.setState({
        compare_mn_selectedYear: e.target.value,
        compare_fn_selectedFN:null,
        compare_fn_selectedMonth:null,
        compare_fn_selectedYear:null,
        compareLeftDate:null,
      })
    }
  }
  compare_fn_YearChange= (e) => {

    this.props.setSelectedFNLayer("", "")

    if (e.target.value !== '#') {
      this.compare_fn_getMonths(e.target.value)
      this.setState({
        compare_fn_selectedYear: e.target.value,
        compareLeftDate:null,
        compare_mn_selectedMonth:null,
        compare_mn_selectedYear:null,
      })
    }
  }

  compare_fn_MonthChange = (e) => {
    this.props.setSelectedFNLayer("", "")
    
    if (e.target.value !== '#') {
      this.setState({
        compare_fn_selectedMonth: e.target.value,
        compareLeftDate:null,
        compare_mn_selectedMonth:null,
        compare_mn_selectedYear:null,
      })
      this.compare_fn_getFN(e.target.value)
    }
  }

  compare_fn_getFN = (e) => {
    //consolee.log('E', e)
    //consolee.log('MOnts', this.props.fortnightly_dates)

    let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.compare_fn_selectedYear && item.month === e))

    //consolee.log('Find', find1)

    this.setState({
      compare_fn_yrMonFN: find1
    })
  }



  compare_fn_getMonths = (e) => {
    // let mn_yrMonths = [];
    let months = new Set();

    let find1 = this.props.fortnightly_dates.filter((item) => (item.year === e))

    find1.map((item) => {
      months.add(item.month);
    });
    
    //consolee.log('MOnts', this.props.fortnightly_dates)
    //consolee.log('Find', find1)

    this.setState({
      compare_fn_yrMonths: Array.from(months)
    })
  }
  compare_mn_MonthChange = (e) => {
    if (e.target.value !== '#') {
      // this.mn_getMonths(e.target.value)
      this.setState({
        compare_mn_selectedMonth: e.target.value,
        compare_fn_selectedFN:null,
        compare_fn_selectedMonth:null,
        compare_fn_selectedYear:null,
        compareLeftDate:null,
      })
    }
  }

  compare_FNChange = (e) => {
    if (e.target.value !== '#') {
      // this.mn_getMonths(e.target.value)

      
      this.setState({
        compare_fn_selectedFN: e.target.value
      })
      if(this.props.selectedMenu==="et-Evapotranspiration-Fortnightly750")
      {
        //consolee.log("selected product in if ",this.props.selectedMenu)
        let product="AET"
        this.setState({
          product:product

        }) 
        let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.compare_fn_selectedYear && item.month === this.state.compare_fn_selectedMonth && item.fortnight === e.target.value));

      this.props.setSelectedFNLayer(find1[0].layerdate, find1[0].fortnight,product)
        //consolee.log("selected product from product:",this.props.productselected)
      }

      if(this.props.selectedMenu!=="et-Evapotranspiration-Fortnightly750")
      {
        //consolee.log("selected product elseif",this.props.selectedMenu)
        let product=(this.props.selectedMenu).split("-")[0].toUpperCase()
        this.setState({
          product:product

        }) 
        let find1 = this.props.fortnightly_dates.filter((item) => (item.year === this.state.compare_fn_selectedYear && item.month === this.state.compare_fn_selectedMonth && item.fortnight === e.target.value));

      this.props.setSelectedFNLayer(find1[0].layerdate, find1[0].fortnight,product)
        //consolee.log("selected product from product:",this.props.productselected)
      }
      
    }
  }
  handleCommandChange=(e)=>
  {
 
    axios.post(`${domain.DBServer}/get-et-command-boundary/${e.target.value}`).then((result) => {
      if (result) {
        this.setState({
          customshapeselected:"#",
          boundary: result.data[0].boundary,
          timeserieschartdata:null,
          timeserieschartdates:null,
          visibleGraphPanel1:false,
          visualizeTimeChart:false,
          buttonColor:"white",
          drawGeojson:null,
          shapefilegeom:null,

        });
      }
    });
    // let productname=this.state.productselected.replace(/\s/g, '_');

    // if (productname==="et")
    // {
    //   productname="aet_Evapotranspiration"
    // }
    // let timestamp=this.state.timestampselected
    // let tablename = productname.toLowerCase() + '_' + timestamp.toLowerCase() + '750';


    this.setState({
      commandselected:e.target.value,
      boundary:null,
      analysisnameselected:"command",
      //tablename:tablename,
      areaselected:e.target.value,

    })
    ////consolee.log("tablenameeeeeeeeeeeeeeeecommandee",tablename,timestamp,productname)

    // axios.get(`${domain.DBServer}/get-et-command-stats/${e.target.value}/${this.state.selectedStrtMon}/${this.state.selectedEndMon}/${this.state.selectedStrtYear}/${this.state.selectedEndYear}/${tablename}`).then((result) => {
    //   if (result) {
    //     //consolee.log("resultttt of command stats",result.data)
    //     this.setState({
    //       analysistimeseriesdata: result.data,
    //    });
    //   }
    // });

  }
  handleBasinChange=(e)=>
  { 
    axios.post(`${domain.DBServer}/get-et-basin-boundary/${e.target.value}`).then((result) => {
      if (result) {
        this.setState({
          customshapeselected:"#",
          boundary: result.data[0].boundary,
          timeserieschartdata:null,
          timeserieschartdates:null,
          visibleGraphPanel1:false,
          visualizeTimeChart:false,
          buttonColor:"white",
          drawGeojson:null,
          shapefilegeom:null,

                     
          });
      }
    });
    let productname=this.state.productselected.replace(/\s/g, '_');

    // if (productname==="et")
    // {
    //   productname="aet_Evapotranspiration"
    // }
    // let timestamp=this.state.timestampselected
    // let tablename = productname.toLowerCase() + '_' + timestamp.toLowerCase() + '750';
     this.setState({
      basinselected:e.target.value,  
        analysisnameselected:"basin",
        //tablename:tablename,
        areaselected:e.target.value,
      })
    }
   
  handleCustomChange =(e)=>
  {

    this.setState({
     customshapeselected:e.target.value,
     shapefilegeom:null,
     drawgeojson:null,
     boundary:null,
     areaselected:"#",
     
     timeseriesOperationselected:"#",
     timeserieschartdata:null,
     timeserieschartdates:null,
     visualizeTimeChart:false,
     visibleGraphPanel:false,
     visibleGraphPanel1:false,
     shapefileData:null,
    // tablename:tablename
     
    })
  };
 
  handleFileUpload = async (event) => {
    this.setState({ shapefilegeom:null,
      timeserieschartdata:null,
      timeseriesOperationselected:"#",
    });
    const file = event.target.files[0];


    let productname=this.state.productselected.replace(/\s/g, '_');

     this.setState({ shapefileData: null,shapefilegeom:null})

  
    // Check if the file is a zip file
    if (!file || !file.name.toLowerCase().endsWith('.zip')) {
      // Show an error message to the user
      alert('Please upload a .zip file');
      return;
    }
  
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const geojson = await shp(reader.result);
        
        // Check if the shapefile contains points
        const hasPoints = geojson.features.some(feature => feature.geometry.type === 'Point');
        
        if (hasPoints) {
          alert('Please upload a polygon shapefile. Point shapefiles are not supported.');
          return;
        }
        
      const geometry = geojson.features.map(feature => feature.geometry);
       this.setState({ shapefileData: geojson});
       this.setState({ shapefilegeom:geometry});
      } catch (error) {
        // Handle error while parsing shapefile
        //consolee.error('Error parsing shapefile:', error);
        // Show an error message to the user
        alert('Error parsing shapefile. Please make sure the uploaded file is a valid shapefile.');
      }
    };
    reader.readAsArrayBuffer(file);
  }

  handleTimeseriesChange=(e)=> {

    this.setState({
      timeseriesOperationselected:"#"
    })
    let timeseriesOperationselected =e.target.value
  
    if(timeseriesOperationselected!="#")
    {
    this.setState({
      timeseriesOperationselected:e.target.value,
      visualizeTimeChart:false,
      timeserieschartdata:null,
      timeserieschartdates:null,
      visibleGraphPanel:false,
      visibleGraphPanel1:false,
      buttonColor:"white",   
      chartData:null,
     })
    
    }

  }
 
  handleMouseDown() {
    this.setState(prevState => ({ isDraggable: !prevState.isDraggable }));
  }

  handleMouseUp() {
    this.setState({ isDraggable: false });
  }
  mn_HandleChange = (event, { name, value }) => {
    this.setState({ [name]: value });
  };
  
  preventDragHandler = (e) => {
    e.preventDefault();
  };

  render() {
    let productList ,areas_list=[],districtlist=[],mnYearsOpt,mnMonthsOpt,fortnightYears, fnMonthsOpt, fnMonthFNOpt,mnYearsOptR,mnMonthsOptR,fortnightYearsR, fnMonthsOptR, fnMonthFNOptR;
    //consolee.log("all values",this.state.shapefileData,this.state.drawGeojson,this.state.areaselected,this.state.visualizeTimeChart, this.state.timeseriesOperationselected)
    //consolee.log("this.state.timeserieschartdata",this.state.timeserieschartdata)
    if (this.props.monthly_yrs) {


      mnYearsOpt = this.props.monthly_yrs.map((item) => {
        return (<option value={item}>{item}</option>)
      })
    }
    if (this.state.compare_mn_yrMonths) {
      // Convert array to Set to remove duplicates, then convert it back to array
      const uniqueMonths = [...new Set(this.state.compare_mn_yrMonths.map(item => item.month))];
      
      // Map the unique months to options
      mnMonthsOpt = uniqueMonths.map((month, index) => (
        <option key={index} value={month}>{month}</option>
      ));
    }
    if (this.state.compare_fn_yrMonFN) {
      fnMonthFNOpt = this.state.compare_fn_yrMonFN.map((item) => {
        return (<option value={item.fortnight}>{item.fortnight}</option>)
      })
      //consolee.log('MYMNbbbbbbbbbbbbbbbbbbbbbbb1', fnMonthFNOpt);
    }

    if (this.props.fortnightly_yrs) {
      fortnightYears = this.props.fortnightly_yrs.map((item) => {
        return (<option value={item}>{item}</option>)
      })
    }

    if (this.state.compare_fn_yrMonths) {
      fnMonthsOpt = this.state.compare_fn_yrMonths.map((item) => {
        return (<option value={item}>{item}</option>)
      })
      //consolee.log('FNMN1', fnMonthsOpt);
    }
    //-----------------------------------------------------------------------------------
    if (this.props.monthly_yrs) {

      //consolee.log(  "dates availllllllllllllllllinside the if years",this.props.monthly_dates, this.props.monthly_yrs )

      mnYearsOptR = this.props.monthly_yrs.map((item) => {
        return (<option value={item}>{item}</option>)
      })
      //consolee.log('MYyyyyyyyyyyyyyyyyyyyyyyyyyyrrrrrrrrrrrrrrr1', mnYearsOptR,this.props.monthly_yrs);
    }
    if (this.state.compare_mn_yrMonthsR) {
      const uniqueMonths = [...new Set(this.state.compare_mn_yrMonthsR.map(item => item.month))];
      
      // Map the unique months to options
      mnMonthsOptR = uniqueMonths.map((month, index) => (
        <option key={index} value={month}>{month}</option>
      ));
      //consolee.log('MYMNdddddddddddddddddddd1', mnMonthsOpt);
    }
    if (this.state.compare_fn_yrMonFNR) {
      fnMonthFNOptR = this.state.compare_fn_yrMonFNR.map((item) => {
        return (<option value={item.fortnight}>{item.fortnight}</option>)
      })
      //consolee.log('MYMNbbbbbbbbbbbbbbbbbbbbbbb1', fnMonthFNOpt);
    }

    if (this.props.fortnightly_yrs) {
      fortnightYearsR = this.props.fortnightly_yrs.map((item) => {
        return (<option value={item}>{item}</option>)
      })
    }

    if (this.state.compare_fn_yrMonthsR) {
      fnMonthsOptR = this.state.compare_fn_yrMonthsR.map((item) => {
        return (<option value={item}>{item}</option>)
      })
      //consolee.log('FNMN1', fnMonthsOptR);
    }

    //---------------------------------------------------------------------------

    const { selectedMonthStart,selectedMonthEnd,compareLeftDate,compareRightDate } = this.state;
    let params = new URLSearchParams(this.props.location.search);
    ////consolee.log("analysisarealist",this.state.analysisarealist)
    //console.log("timeserieschartdata",this.state.timeserieschartdata)
    const initialDate = this.props.availableDates.length > 0 ? moment(this.props.availableDates[0], 'DD-MM-YYYY').toDate() : null;


    //console.log("timeserieschartdatathis.sta",this.state.timeserieschartdata.length)
    //console.log("visualization of ",this.state.visualizeTimeChart)
    //console.log("Start and end ",this.state.selectedMonthStart.getMonth() + 1)
    if (this.state.analysisarealist!=="#") {
      areas_list = this.state.analysisarealist.map((place) => {
        if(place.name!==null){
          return <option value={place.name} key={place.name}>{place.name}</option>;
        }
      });
    }

    if (this.state.districtlist!=="#") {
      districtlist = this.state.districtlist.map((place) => {
        return <option value={place.district}>{place.district}</option>;
      });
    }
    

    //consolee.log("all the display nameeeeeeeeeeeeeeeeees",this.state.tabs)
    if (this.state.tabs) {
      productList = this.state.tabs.map((product) => {
        return <option value={(product.name).split("-")[0]}>{product.displayname}</option>;
      });
    }

    let menuList =this.state.tabs.map((child) => {
      return (
        <div style={{ padding: "5px" }} key={child.id}>
          <TreeNode
            data={child}
            setSelectedLayer={this.props.setSelectedLayer}
            setSelectedMenu={this.props.setSelectedMenu}
            margin={0}
            clickcount={this.state.clickcount}
            incrementCounter={this.incrementCounter}
            active={child.active}
            handleTabClick={this.handleTabClick}
            productselected={this.state.productselected}
            handleDateChange={this.props.handleDateChange}
            color={colors["sidebar-main-menu"]}
            selectedLayerLink={params.get("selected")}
            toggleSelectedNodeStatus={this.props.toggleSelectedNodeStatus}
            selectedNodeStatus={this.props.selectedNodeStatus}
            selectedMenu={this.props.selectedMenu}
            EBPToggle={this.props.EBPToggle}
            date={this.props.date}
            availableDates={this.props.availableDates}
            monthly_dates={this.props.monthly_dates}
            monthly_yrs={this.props.monthly_yrs}
            //handleTabClick={this.handleTabClick}
            setSelectedMNLayer={this.props.setSelectedMNLayer}
            setSelectedFNLayer={this.props.setSelectedFNLayer}
             mn_YearChange={this.props.mn_YearChange}
            mn_selectedYear={this.props.mn_selectedYear}
            mn_selectedMonth={this.props.mn_selectedMonth}
            fortnightly_dates={this.props.fortnightly_dates}
            fortnightly_yrs={this.props.fortnightly_yrs}
            fn_selectedYear={this.props.fn_selectedYear}
            fn_selectedMonth={this.props.fn_selectedMonth}
            fn_selectedFN={this.props.fn_selectedFN}
            inlinemode={this.props.inlinemode}
            modeChange={this.props.modeChange}
          // getAvailableDates={this.getAvailableDates.bind(this)}
          />
        </div>
      );
    });
    //   console.log(this.props.history)

    return (
      <div
        style={{ backgroundColor:colors.textcolor, height: "100%" }}
        ref={(ref) => {
          this._menuBlock = ref;
        }}
      >
        <AboutModal
          modal={this.props.etmodal}
          toggle={this.props.toggle}
          title={pagecontent.title}
          bodycontent={pagecontent.bodycontent}
          link={pagecontent.link}
        />
        <Sidebar.Pushable
          as={Segment}
          style={{
            marginTop: "0px",
           //ackgroundColor: colors.textcolor,
            border: "0px",
          }}
        >
          <Sidebar
            as={Menu}
            animation="slide out"
            direction="left"
            icon="labeled"
            inverted
            vertical
            visible={this.props.visible}
            // width='wide'
            style={{
              backgroundColor: colors.background,
              textAlign: "right",
              width: "260px",
              padding: "0px",
              border: "0px",
            }}
          >
            
            <div className="modalwindow">
            <div
                as="div"
                onClick={this.MapVisualization}
                className="modalheader"
                style={{ textAlign: "left" }}
              >
             <div style={{ display: "flex" }}>
                  <div style={{ width: "80%" }}> Map Visualization</div>
                  <div style={{ textAlign: "right", width: "20%" }}>
                    {this.state.collapsed ? (
                      <FontAwesomeIcon icon="angle-down" />
                    ) : (
                        <FontAwesomeIcon icon="angle-right" />
                      )}
                  </div>
                </div>
              </div>

              {this.state.collapsed ? (
                <div
                  style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",  
                    color:colors.textcolor  /* vertically centers items */
                  }}
                >
             

                {menuList}
              </div>
               ) : null}
               </div>

               <div className="modalwindow">
            <div
                as="div"
                onClick={this.AnalysisTool}
                className="modalheader"
                style={{ textAlign: "left" }}
              >
             <div style={{ display: "flex" }}>
                  <div style={{ width: "80%" }}> Analysis Tool</div>
                  <div style={{ textAlign: "right", width: "20%" }}>
                    {this.state.collapsed1 ? (
                      <FontAwesomeIcon icon="angle-down" />
                    ) : (
                        <FontAwesomeIcon icon="angle-right" />
                      )}
                  </div>
                </div>
              </div>

              {this.state.collapsed1 ? (
                <div>
                <div
                  style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    display:"grid",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center", 
                    
                  }}
                >
                  <select  
                    onChange={this.handleProductChange}
                    value={this.state.productselected}
                    selected={this.state.productselected}
                  >
                    <option value="#" selected>
                      Select Product
                    </option>
                   {/*
                    <option value="AET">
                      Actual Evapotranspiration</option>
                    <option value="PET">
                     Potential Evapotranspiration</option>
                    <option value="MAI">
                    Moisture Adequacy Index</option>
                    <option value="ESI">
                    Evaporation Stress Index </option>
                   
                */}
                {productList}
                </select>
                </div>
                
                <div style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    //textAlign: "-webkit-center",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",   
                    display:"grid",
                  }}>
                {this.state.productselected!=="#" && (
                  <select
                    onChange={this.handleTimestampChange}
                    value={this.state.timestampselected}
                  >
                    <option value="#" >Select TimeStep </option>
                    <option value="Fortnightly">
                      Fortnightly</option>
                    <option value="Monthly">
                     Monthly</option>
                  </select>
                   )}
                   </div>



                   {this.state.timestampselected !== "#" && (
                 <div style={{
                    background: colors["final_side_sub"],
                    padding: "0px 10px 0px 3px",
                    
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",   
                    display:"grid",
                  }}>

                
                    
                    <DatePicker
                    //showIcon
                      selected={selectedMonthStart}
                      onChange={this.handleDateChangeRangeStart}
                      //selectsStart
                      //startDate={startDate}
                    // endDate={endDate}
                      minDate={this.state.AnalaysisminDate}
                      maxDate={this.state.AnalaysismaxDate}
                      dateFormat="MMM yyyy"
                      showMonthYearPicker
                      placeholderText=" Select Start Date"
                      className="custom"

                      filterDate={this.isAvailableMonthYear}
                      dayClassName={this.getDayClassName}



                    />
                                           
                      <DatePicker
                        //showIcon
                          selected={selectedMonthEnd}
                          onChange={this.handleDateChangeRangeEnd}
                          dateFormat="MMM yyyy"
                          showMonthYearPicker
                          minDate={this.state.AnalaysisminDate}
                          maxDate={this.state.AnalaysismaxDate}
                          
                          placeholderText="  Select End Date"
                          className="custom"
                          filterDate={this.isAvailableMonthYear}


                       />
                </div>
                  )}
                <div style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    //textAlign: "-webkit-center",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",   
                    display:"grid",
                  }}>
                {this.state.timestampselected!=="#" && (
                  <select
                    onChange={this.handleAnalaysisChange}
                    value={this.state.analysisselected}
                  >
                    <option value="#">Area of Interest </option>
                    <option value="commands"> Command Area </option>
                    <option value="adminstate"> Administrative </option>
                    <option value="basins"> Basin </option>
                    <option value="Custom"> Custom </option>
                    
                  </select>
                )}
                </div>
           <div style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    //textAlign: "-webkit-center",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",   
                    display:"grid",
                  }}>
              {this.state.analysisselected === "commands" && (

                  <select
                    onChange={this.handleCommandChange}
                    value={this.state.commandselected}
                  >
                    <option value="#">Select Command Area </option>
                      {areas_list}
                    </select>
              )}
                 </div>

                 <div style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",   
                    display:"grid",
                  }}>
              {this.state.analysisselected === "adminstate" && (
                  <div style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",   
                    display:"grid",
                    
                    
                  }}>
                  <select
                    onChange={this.handleAdministrativeStateChange}
                    value={this.state.administrativestateselected}
                  >
                    <option value="#">Select State </option>
                    {areas_list}
                    </select>
                      <div style={{
                        background: colors["final_side_sub"],
                        padding: "0px",
                        justifyContent: "center", /* horizontally centers items */
                        alignItems: "center",   
                        display:"grid",
                      }}>
                        </div>
                    {this.state.administrativestateselected !== "#" && (
                    <select
                    onChange={this.handleAdministrativeDistrictChange}
                    value={this.state.administrativedistrictselected}
                  
                    >
                    <option value="#">All Districts </option>
                    {districtlist}

                    </select>
                    )}
                    </div>

              )}
                 </div>
                 <div style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",   
                    display:"grid",
                  }}>
              {this.state.analysisselected === "basins" && (

                  <select
                    onChange={this.handleBasinChange}
                    value={this.state.basinselected}
                  >
                    <option value="#">Select Basin</option>
                    {areas_list}
                    </select>

              )}
                 </div>
                 <div style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                  
                  }}>
              {this.state.analysisselected === "Custom" && (
                <div style={{ width: "90%", opacity: "1.0" ,padding: "5px"}}>
                <div style={{textAlign:"center"}} >
              <input  type="radio"
              name="custom"
              value="draw"
              checked={this.state.customshapeselected=== "draw"}
              onChange={this.handleCustomChange}
              //disabled={true}
                />        
                   {" Draw on Map"}
              </div>
              
            
                   <div style={{ width: "90%", opacity: "1.0" ,paddingRight: "8px"}}>
                 
                   <input  type="radio"
                   name="custom"
                   value="upload"
                   checked={this.state.customshapeselected === "upload"}
                   onChange={this.handleCustomChange}
                   //disabled={true}
                     />
    
                        {" Upload a shapefile"}
                        </div>

                        { this.state.customshapeselected === "upload" &&  <input type="file" accept=".zip" onChange={this.handleFileUpload} />}
                        </div>

              )}
                 </div>
                 {(this.state.areaselected!=='#'|| this.state.shapefilegeom!==null|| this.state.drawGeojson!==null) && (

                <div
                  style={{
                    background: colors.final_side_sub,
                    color: colors.text_sub_color,
                    padding: "10px",
                  }}
                >
                  <div
                    style={{ textAlign: "left", color: colors.text_sub_color }}
                  >
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "10%" }}>
                        <input type="radio"        
                        name="analysis"
                        value="time"
                        checked={this.state.selectedAnalysisForTimeseriesSpatial === "time"}
                        onChange={this.AnalysisForTimeseriesSpatialTool} 
                       // disabled={true}
                       />
                      </div>

                      <div style={{ width: "90%", opacity: "", padding: "0px"}}>
                      Time Series Analysis
                      
                        {this.state.selectedAnalysisForTimeseriesSpatial === "time"&& (
                      <div>
  
         
                          <div
                                      style={{
                                      background: colors["final_side_sub"],
                                      padding: "10px 0px 0px 0px",
                                      justifyContent: "center", /* horizontally centers items */
                                      alignItems: "center",   
                                      display:"grid",
                                         }}
                 >
      

                    <select
                      onChange={this.handleTimeseriesChange}
                      value={this.state.timeseriesOperationselected}
                      selected={this.state.timeseriesOperationselected}
                    >
                    <option value="#" selected>
                      Spatial Operations
                    </option>
                      
                    <option value="Mean">
                        Mean</option>
                  

                </select>
                </div>  
                
                  {this.state.timeseriesOperationselected && (
                    <div  style={{
                        background: colors["final_side_sub"],
                        padding: "10px 0px 0px 0px",
                        justifyContent: "center", /* horizontally centers items */
                        alignItems: "center",   
                        display:"grid",
                        color:"red"
                      }}>

                      <button type="button" onClick={this.handleTimeseriesChartGen} disabled={this.state.visualizeTimeChart || this.state.timeseriesOperationselected==="#" }style={{ backgroundColor: this.state.buttonColor }}> 
                      {this.state.visualizeTimeChart? 'Generating..' : 'Generate Plot'}
                      
                      </button> 
                            {this.state.visualizeTimeChart && (
                              <div style={{ display: 'grid', justifyContent: 'center', alignItems: 'center' }}>

                                  {/* <TailSpin
                                  height="50"
                                  width="50"
                                  color="#217CA3"
                                  ariaLabel="tail-spin-loading"
                                  radius="0.1"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                  visible={true}
                              /> */}
                              <FadeLoader color="#217CA3" loading={this.state.visualizeTimeChart} height={15} width={5} radius={2} margin={2} />

                              </div>
                            )}      

                   </div>
                  )}
                      
              </div>
            )}
          </div>
        </div>
      </div>
                
     </div> 

                
      )}
     </div>

          ) : null}
          </div>

              <div className="modalwindow">
            <div
                as="div"
                onClick={this.ComparisonTool}
                className="modalheader"
                style={{ textAlign: "left" }}
              >
             <div style={{ display: "flex" }}>
                  <div style={{ width: "80%" }}>  Comparison Tool</div>
                  <div style={{ textAlign: "right", width: "20%" }}>

             
              <Popup
            trigger= {this.state.collapsed4 ? (
                      <FontAwesomeIcon icon="angle-down" />
                    ) : (
                        <FontAwesomeIcon icon="angle-right" />
                      )}
                      content="Spatial differentiation between two products"
                      on="click"
                      position="top right"/>

                  </div>
                </div>
              </div>

              {this.state.collapsed4
               ? (
                <div
                  style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    
                  }}
                >
                 <b style={{

                  display:"flex",
                  justifyContent: "center", /* horizontally centers items */
                  alignItems: "center",   
                 }}  > Left Panel</b>
                  <div
                  style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    display:"grid",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",
                  }}
                >
                  <select
                    onChange={this.handleProductChange}
                    value={this.state.productselected}
                    selected={this.state.productselected}
                  >
                    <option value="#" selected>
                      Select Product
                    </option>

                {productList}

                </select>
                


                {((this.state.productselected==="et" || this.state.productselected==="PET Evapotranspiration" )&& (
          <select
            onChange={this.handleTimestampChange}
            value={this.state.timestampselected}
          >
            <option value="#">Select TimeStep</option>
           
            <option value="Fortnightly">Fortnightly</option>
            <option value="Monthly">Monthly</option>
          </select>
        )) || (
          <select
            onChange={this.handleTimestampChange}
            value={this.state.timestampselected}
          >
            <option value="#">Select TimeStep</option>
            <option value="Fortnightly">Fortnightly</option>
            <option value="Monthly">Monthly</option>
          </select>
        )}



                   {(this.state.timestampselected === "Daily" && (this.state.productselected==="PET Evapotranspiration" ||this.state.productselected==="et")) && (
                 <div style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",   
                  }}>                
            
                  <DatePicker
                 
                selected={compareLeftDate}
                onChange={this.handleDateChangeCompareLeft}
                dateFormat="dd/MM/yyyy"
                highlightDatesStyles="orange"
                //initialMonth={moment(this.props.availableDates[0], 'DD-MM-YYYY').toDate()} // Set initial month to the month of the earliest available date

                highlightDates={this.props.availableDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={15}
                closeOnSelect // Close the date picker automatically on select
                openToDate={initialDate}
                shouldCloseOnSelect={true}
                placeholderText="  Select Date"
                

                  />

              </div>
               
                )}
             

                {(this.state.timestampselected === 'Monthly' && this.state.productselected!=="#") && (

					      <div >
			
                <div>
                <select value={this.state.compare_mn_selectedYear} selected={this.state.compare_mn_selectedYear} onChange={this.compare_mn_YearChange}>
                  <option value="#" >Select Year</option>
                  {mnYearsOpt}
                </select>

              </div>
						 
						  <select selected={this.state.compare_mn_selectedMonth} value={this.state.compare_mn_selectedMonth} onChange={this.compare_mn_MonthChange}>
                <option value="#">Select Month</option>
                {mnMonthsOpt}
						  </select>
						  
						</div>
				
                )}
            
                 {(this.state.timestampselected === 'Fortnightly' && this.state.productselected!=="#") && (
         
        <>
         <select value={this.state.compare_fn_selectedYear} selected={this.state.compare_fn_selectedYear} onChange={this.compare_fn_YearChange}>
              <option value="#" >Select Year</option>
              {fortnightYears}
					  </select>
					
					  <select selected={this.state.compare_fn_selectedMonth} value={this.state.compare_fn_selectedMonth} onChange={this.compare_fn_MonthChange}>
              <option value="#">Select Month</option>
              {fnMonthsOpt}
					  </select>
					 
					  <select selected={this.state.compare_fn_selectedFN} value={this.state.compare_fn_selectedFN} onChange={this.compare_FNChange}>
              <option value="#">Select Fortnight</option>
              {fnMonthFNOpt}
					  </select>
    
     
              </>  
            )}
             <div style={{ background: colors["final_side_sub"], padding: "10px 0px",   display: "flex", justifyContent: "space-between" }}>
                  <div style={{margin:"3%",marginTop:"0%",marginBottom:"0%"}}  >
                  
                <button type="button" onClick={this.handleCompareLeftUpload} disabled={(this.state.compareLeftDate===null && this.state.compare_fn_selectedFN===null&& this.state.compare_mn_selectedMonth===null)}>
                  Add to Map
                </button>
                </div>
                  <div style={{margin:"3%",marginTop:"0%",marginBottom:"0%"}}   >
                <button type="button" onClick={this.handleCompareLeftReset}  >
                 Reset
                </button>
              </div>
              </div>

    </div>
                  <br/>
                  <b  style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    display: "flex",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",   
                  }}> Right Panel</b>
                  <div
                  style={{
                    background: colors["final_side_sub"],
                    padding: "0px",
                    display:"grid",
                    justifyContent: "center", /* horizontally centers items */
                    alignItems: "center",

                   
                  }}
                >
                  <select
                    onChange={this.handleProductChangeR}
                    value={this.state.productselectedR}
                    selected={this.state.productselectedR}
                  >
                    <option value="#" selected>
                      Select Product
                    </option>
                
                {productList}
                </select>

                  {((this.state.productselectedR==="et" || this.state.productselectedR==="PET Evapotranspiration" )&& (
                    <select
                      onChange={this.handleTimestampChangeR}
                      value={this.state.timestampselectedR}
                    >
                      <option value="#">Select TimeStep</option>
                     
                      <option value="Fortnightly">Fortnightly</option>
                      <option value="Monthly">Monthly</option>
                    </select>
                  )) || (
                    <select
                      onChange={this.handleTimestampChangeR}
                      value={this.state.timestampselectedR}
                    >
                      <option value="#">Select TimeStep</option>
                      <option value="Fortnightly">Fortnightly</option>
                      <option value="Monthly">Monthly</option>
                    </select>
                  )}

                        {(this.state.timestampselectedR === "Daily" && (this.state.productselectedR==="PET Evapotranspiration" ||this.state.productselectedR==="et")) && (
                      <div style={{
                          background: colors["final_side_sub"],
                          padding: "0px",
                          textAlign: "-webkit-center",
                        }}>                
                  
                          <DatePicker
                          
                        selected={compareRightDate}
                        onChange={this.handleDateChangeCompareRight}
                        dateFormat="dd/MM/yyyy"
                        highlightDatesStyles="orange"
                        //initialMonth={moment(this.props.availableDates[0], 'DD-MM-YYYY').toDate()} // Set initial month to the month of the earliest available date
                        highlightDates={this.props.availableDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                        showYearDropdown
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                        closeOnSelect // Close the date picker automatically on select
                        openToDate={initialDate}
                        shouldCloseOnSelect={true}
                        placeholderText="  Select Date"
                       
                          />
                      </div>  
                      )}
              

                  {(this.state.timestampselectedR === 'Monthly') && (

                    <div >
                    <div>
                      <select value={this.state.compare_mn_selectedYearR} selected={this.state.compare_mn_selectedYearR} onChange={this.compare_mn_YearChangeR}>
                        <option value="#" >Select Year</option>
                        {mnYearsOptR}
                      </select>

                    </div>				
                    <select selected={this.state.compare_mn_selectedMonthR} value={this.state.compare_mn_selectedMonthR} onChange={this.compare_mn_MonthChangeR}>
                      <option value="#">Select Month</option>
                      {mnMonthsOptR}
                    </select>
                  </div>
                      )}
                
                  {(this.state.timestampselectedR === 'Fortnightly') && (
              
                <div>
                <select value={this.state.compare_fn_selectedYearR} selected={this.state.compare_fn_selectedYearR} onChange={this.compare_fn_YearChangeR}>
                      <option value="#" >Select Year</option>
                      {fortnightYearsR}
                    </select>
                  
                    <select selected={this.state.compare_fn_selectedMonthR} value={this.state.compare_fn_selectedMonthR} onChange={this.compare_fn_MonthChangeR}>
                      <option value="#">Select Month</option>
                      {fnMonthsOptR}
                    </select>
                  
                    <select selected={this.state.compare_fn_selectedFNR} value={this.state.compare_fn_selectedFNR} onChange={this.compare_FNChangeR}>
                      <option value="#">Select Fortnight</option>
                      {fnMonthFNOptR}
                    </select>
            
                    </div>

                  
                )}
                
                   
                <div style={{ background: colors["final_side_sub"], padding: "10px 0px",   display: "flex", justifyContent: "space-between" }}>
                <div style={{margin:"3%",marginTop:"0%",marginBottom:"0%"}}  >
                <button type="button" onClick={this.handleCompareRightUpload} disabled={(this.state.compareRightDate===null && this.state.compare_fn_selectedFNR===null&& this.state.compare_mn_selectedMonthR===null)}>
                Add to Map
                </button>
                </div>
                <div style={{margin:"3%",marginTop:"0%",marginBottom:"0%"}}   >
                <button type="button" onClick={this.handleCompareRightReset}  >
                Reset
                </button>
                </div>
                </div>
</div>
                </div>

              ):null}
              </div>


              

              
            <div className="modalwindow">
              <div
                className="modalheader"
                style={{ color: colors.textcolor, textAlign: "left" }}
              >
                Information
              </div>

              <div className="modalbox">
                {/* Inundation layers will be displayed during flood event only */}
                <ul>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.props.technicalNodeToggle}
                  >
                    <a style={{ textDecoration: "underline" }}>
                      Technical Note{" "}
                    </a>
                  </li>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.props.disclaimerToggle}
                  >
                    <a style={{ textDecoration: "underline" }}> Disclaimer</a>
                  </li>
                </ul>
              </div>
            </div>
          </Sidebar>

          <Sidebar.Pusher
            dimmed={false}
            style={{ height: "100%", border: "0px" }}
          >
            <Segment
              basic
              style={{
                width: "100%",
                height: "100%",
                padding: "2px",
                border: "0px",
                margin: "0px",
              }}
            >
              <MapView
                india_states_boundary={this.state.india_states_boundary}
                
                latlng={this.props.latlng}
                showInfo={this.props.showInfo}
                pointInfo={this.props.pointInfo}
                legendVisible={this.props.legendVisible}
                displayLegend={this.displayLegend}
                markerPosition={[28.613, 77.209]}
                selected={this.props.selectedMenu}
                chartData={this.props.chartData}
                chartloading={this.props.chartloading}
                setLegend={this.props.setLegend}
                selectedLayer={this.props.selectedLayer}
                mn_selectedLayer = {this.props.mn_selectedLayer}
                fn_selectedLayer = {this.props.fn_selectedLayer}
                visibleLeft={this.props.visible}
                visibleGraphPanel={this.props.visibleGraphPanel}
                visibleGraphPanel1={this.state.visibleGraphPanel1}
                collapsed4={this.state.collapsed4}
                collapsed1={this.state.collapsed1}
                collapsed={this.state.collapsed}
                compare_fn_selectedFN={this.state.compare_fn_selectedFN}
                compare_fn_selectedFNR={this.state.compare_fn_selectedFNR}
                compare_fn_selectedMonth={this.state.compare_fn_selectedMonth}
                compare_fn_selectedMonthR={this.state.compare_fn_selectedMonthR}
                compare_fn_selectedYear={this.state.compare_fn_selectedYear}
                compare_fn_selectedYearR={this.state.compare_fn_selectedYearR}
                compare_mn_selectedMonth={this.state.compare_mn_selectedMonth}
                compare_mn_selectedMonthR={this.state.compare_mn_selectedMonthR}
                compare_mn_selectedYear={this.state.compare_mn_selectedYear}
                compare_mn_selectedYearR={this.state.compare_mn_selectedYearR}






                productselected={this.state.productselected}
                productselectedR={this.state.productselectedR}
                timestampselected={this.state.timestampselected}
                timestampselectedR={this.state.timestampselectedR}

                compareLeftDate={this.state.compareLeftDate}
                compareLeftWorkspace={this.state.compareLeftWorkspace}
                compareRightDate={this.state.compareRightDate}
                shapefileData={this.state.shapefileData}
                compareRightWorkspace={this.state.compareRightWorkspace}
                compareLeftLayer={this.state.compareLeftLayer}
                compareRightLayer={this.state.compareRightLayer}
                customshapeselected={this.state.customshapeselected}
                //collapsed={this.state.collapsed}
               // shapeFileData={this.state.shapeFileData}
                handleAnimationChange={this.props.sidebarToggle}
                handleVisibleGraphPanelOnMapClick={
                  this.handleVisibleGraphPanelOnMapClick
                }
                stopVisualisationLeft={this.state.stopVisualisationLeft}
                stopVisualisationRight={this.state.stopVisualisationRight}
                //productselected={this.state.productselected}
                toggleVisibleGraphPanel={this.props.toggleVisibleGraphPanel}
                toggleVisibleGraphPanel1={this.toggleVisibleGraphPanel1}
                onMapClick={this.props.onMapClick}
                setStateInfo={this.setStateInfo}
                handleSaveGeoJSON ={this.handleSaveGeoJSON }
                // activeDate ={this.state.date}


                activeDate={moment(
                  this.props.availableDates[this.props.slideTracker],
                  "YYYYMMDD"
                ).format("D MMM YYYY")}
                makeChartDataAvailableDays={
                  this.props.makeChartDataAvailableDays
                }
                sliderOptions={{
                  onClickSlideLeft: this.props.onClickSlideLeft,
                  onClickSlideRight: this.props.onClickSlideRight,
                  onSlide: this.props.onSlide,
                  slideTracker: this.props.slideTracker,
                  max: this.props.availableDates.length - 1,
                  date: moment(
                    this.props.availableDates[this.props.slideTracker],
                    "YYYYMMDD"
                  ).format("D MMM YYYY"),
                }}
                boundary={this.state.boundary}
              />
            </Segment>

            {this.props.EB_popup || this.props.WB_popup ? (
            <Rnd
                style={{ zIndex: "200", background: "white" }}
                default={{
                  x: this.props.x,
                  y: this.props.y,
                  width: this.props.width,
                  height: this.props.height,
                }}>
                
                <div class="dialog_header">
                  <div
                    class="closebox"
                    onClick={this.props.handleDialogClose}
                  ></div>
                  {this.props.EB_popup
                    ? "Evapotranspiration "
                    : this.props.WB_popup
                      ? "Evapotranspiration (WB)"
                      : null}
                </div>
                {this.props.EB_popup ? (
                  <EBPopuup />
                ) : this.props.WB_popup ? (
                  <WBPopup />
                ) : (
                      <div className="sweet-loading">
                        <FadeLoader
                          sizeUnit={"px"}
                          color={"#123abc"}
                          loading={this.state.chartloading}
                        />
                      </div>
                    )}
              </Rnd>
            ) : null}

            {this.props.technicalnote || this.props.disclaimer ? (
              <Rnd 
                style={{ zIndex: "200", background: "white" }}
                default={{
                  x: this.props.x,
                  y: this.props.y,
                  width: this.props.width,
                  height: this.props.height,
                }}
                onDragStop={(e, d) => {
                  e.stopPropagation();
                  // this.setState({ x: d.x, y: d.y });
                }}
              >
                {this.props.technicalnote ? (
                  <div id="divDialog" class="dialog boxshadow" >
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.props.handleDialogClose}
                      ></div>
                      Technical Note
                    </div>

                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    >
                      <div class="dialog_content" style={{ overflowY: "auto" }}>
                        <p align="justify">
                          Actual evapotranspiration (AET) is a major component of the hydrological cycle. Major application of evapotranspiration is crop water requirement estimation, drought monitoring, crop stress assessment and irrigation scheduling. Evapotranspiration monitoring is crucial for the effective utilization of water resources to improve agriculture production. This product can be utilized in  hydrological, agricultural and climatological applications domain.
                        </p>
                        <p  ><span style={{ color: "blue" }}>Evapotranspiration EB ( Energy Balance)</span></p>
                        <p align="justify">
                          National Remote Sensing Centre (NRSC) is one of the implementing
                          agencies under National Hydrology Project (NHP). Under NHP, NRSC is
                          establishing evaporative flux monitoring system for entire India.
                          Under this project, it is proposed to estimate evaporative flux with
                          space-based input along with meteorological data. Towards
                          development of evaporative flux monitoring system for Indian region
                          NRSC has developed procedure for daily evaporative flux estimation
                          based on satellite remote sensing data at an appropriate spatial
                          scale.
          </p>{" "}
                        <p align="justify">
                          Evapotranspiration (ET) is the process by which the water gets
                          transported from soil and/or the vegetation to the at
                          phere. In
                          this process the energy also gets transported from land to
                          atmosphere. The main drivers for this process are i) solar
                          radiation, ii) vapour pressure gradient between the evaporating
                          surface and the atmosphere and iii) the resistance that the land
                          cover offers to the process. ET can be determined by direct
                          measurement or estimated through hydro meteorological parameters.
                          Beside direct methods, there were many empirical and analytical
                          methods are developed to calculate ET from the meteorological data
                          and energy fluxes.
          </p>
                        <p align="justify">
                          Analytical methods estimate ET based on the meteorological
                          parameters and energy fluxes. Using these methods, ET can be
                          determined by energy balance or mass (water) balance approach. Under
                          this project these two approaches are implemented and products are
            being disseminated through NHP portal.{" "}
                        </p>
                        <p align="justify">
                          The energy balance principle is based on net exchange of energy,
                          which is constant between earth and atmosphere.ET can be calculated
                          as a residual of the surface energy (Rn), sensible heat flux and
                          soil heat flux.
          </p>
                        <p>
                          λE=Rn-G-H Where λE is the latent heat flux, Rn is the net radiation,
                          G is the soil heat flux and H is the sensible heat flux, expressed
                          in W/m<sup>2</sup>.
          </p>
                        <p align="justify">
                          Energy balance based AET product is estimated from mentioned surface
                          energy balance algorithm equation. Satellite remote sensing is
                          promising tool which has been used to provide reasonable estimate of
                          ET under the assumption that energy storage by the canopy is
                          negligible. Components of surface energy balance equation are
                          derived using satellite remote sensing data and meteorological
                          datasets. Estimated surface energy balance components from input
                          data are used in Modified Priestley Taylor (PT) algorithm (Ai &amp;
                          Yang, 2016; Priestley &amp; Taylor, 1972; Parlange &amp; Katul,
                          1992) to estimate daily actual evapotranspiration product.
          </p>
                        <p align="justify">
                          ET product derived at 5.5km<sup>2</sup> spatial resolution at a daily time
                          interval over the entire Indian subcontinent. The input data sets
                          used in this approach can be categorized as meteorological data sets
                          and satellite data sets. Inputs from 3 different satellite platform
                          (INSAT-3D, Suomi-NPP and Cartosat-1)and two metrological data sets
                          (air temperature and dew point temperature) are used to estimate the
                          daily AET product. Latent heat flux (λE) is estimated for the Indian
                          region from given equation for clear sky condition and equivalent
                          evaporation amount in mm/day is estimated for the instantaneous
                          satellite time pass. Estimated flux value is integrated to daily
                          estimate of AET in mm/day for day length over the spatial domain.
                          End product i.e. daily AET product estimated from mentioned approach
                          is given for dissemination to the end user. Due to different lag
                          time associated with input data sets, AET product based on energy
                          balance estimate is available with 3 day lag time. Experimental AET product is being generated at 5.5 km<sup>2</sup> spatial resolution under National Hydrology Project (NHP) from 2019 onwards. Model generated high quality AET maps across India captures information for much needed AET estimates at daily time scale.
          </p>
                        <p align="justify">
                          References
            <ol>
                            <li>
                              Ai, Zhipin, and Yonghui Yang. "Modification and Validation of
                              Priestley–Taylor Model for Estimating Cotton Evapotranspiration
                              under Plastic Mulch Condition." Journal of Hydrometeorology
                              (American Meteorological Society) 17, no. 4 (April 2016):
                              1281–1293.
              </li>

                            <li>
                              Ali, Z., and Y. Yang. "Modification and Validation of
                              Priestley–Taylor Model for Estimating Cotton Evapotranspiration
                              under Plastic Mulch Condition." Journal of Hydrometeorology,
                              2016.
              </li>
                            <li>
                              Parlange, Marc B., and Gabriel G. Katul. "Estimation of the
                              diurnal variation of potential evaporation from a wet bare soil
                              surface." Journal of Hydrology 132, no. 1-4 (March 1992): 71-89.
              </li>
                            <li>
                              Priestley, C. H. B., and R. J. Taylor. "On the Assessment of
                              Surface Heat Flux and Evaporation Using Large-Scale Parameters."
                              Monthly Weather Review 100, no. 2 (February 1972): 81-92.
              </li>
                          </ol>
                        </p>

                        <br />

                        {/* <p  ><span style={{color:"blue"}} >Evapotranspiration WB (Water Balance)</span></p>
                        <p align="justify">
                          National Remote Sensing Centre (NRSC) is one of the implementing
                          agencies under National Hydrology Project (NHP). Under NHP, NRSC is
                          establishing evaporative flux monitoring system for entire India.
                          Under this project, it is proposed to estimate evaporative flux with
                          space-based input along with meteorological data. Towards
                          development of evaporative flux monitoring system for Indian region
                          NRSC has developed procedure for daily evaporative flux estimation
                          based on satellite remote sensing data at an appropriate spatial
                          scale.
          </p>{" "}
                        <p align="justify">
                          Evapotranspiration (ET) is the process by which the water gets
                          transported from soil and/or the vegetation to the atmosphere. In
                          this process the energy also gets transported from land to
                          atmosphere. The main drivers for this process are i) solar
                          radiation, ii) vapour pressure gradient between the evaporating
                          surface and the atmosphere and iii) the resistance that the land
                          cover offers to the process. ET can be determined by direct
                          measurement or estimated through hydro meteorological parameters.
                          Beside direct methods, there were many empirical and analytical
                          methods are developed to calculate ET from the meteorological data
                          and energy fluxes.
          </p>{" "}
                        <p align="justify">
                          Analytical methods estimate ET based on the meteorological
                          parameters and energy fluxes. Using these methods, ET can be
                          determined by energy balance or mass (water) balance approach. Under
                          this project these two approaches are implemented and products are
            being disseminated through NHP portal.{" "}
                        </p>
                        <br />
                        <strong>Soil Water Balance Approach</strong>{" "}
                        <p align="justify">
                          Since modified Priestley Taylor based algorithm relies primarily on
                          datasets from optical satellite sensors, estimation of actual ET
                          using this approach are not consistent in Kharif season due to
                          persistent cloud cover during Monsoon. Therefore, a soil water
                          balance model is developed which computes evapotranspiration by
                          assessing water stress conditions limiting soil evaporation and
                          transpiration from vegetated areas. This soil water balance approach
                          is based on dual crop coefficient approach as described in FAO-56
                          (Allan, 1998).This approach defines adjusted evapotranspiration as:
          </p>
                        ET<sub>adj</sub>=(K<sub>S</sub>K<sub>cb</sub>+K<sub>e</sub>)ET
          <sub>0</sub>---- (1)
          <p align="justify">
                          Where, ET<sub>adj</sub> is known as adjusted evapotranspiration, K
            <sub>s</sub>
                          is known as water stress coefficient, K<sub>cb</sub> is described as
            basal crop coefficient, K<sub>e</sub> is known as soil evaporation
            coefficient. ET<sub>0</sub> is reference evapotranspiration. This
            model derives K<sub>cb</sub> using Leaf Area Index and Vegetation
            Fraction using following relation.{" "}
                        </p>
                        K<sub>cb</sub> = K<sub>cb,min</sub> +K<sub>d</sub>(K<sub>cb,full</sub>
                        -K<sub>cb,min</sub>) --- (2)
          <p align="justify">
                          K<sub>cb,min</sub> is crop coefficient for bare soil and assumed be
            0.15 in the model. The density coefficient (K<sub>d</sub>) is
                          related to crop cover on the ground and hence can be modeled in
                          terms of Leaf Area Index (Pocas, Paco, Perades, Cunha, &amp;
                          Pereira, 2015). The model uses following relationship between Kd and
                          LAI as given by Allen et al., 1998.
          </p>
                        K<sub>d</sub> = (1-e<sup>-0.7LAI</sup>) --- (3)
          <p align="justify">
                          The term in multiplication of K<sub>d</sub> in definition of K
            <sub>cb</sub> can be approximated by the vegetation fraction.
                          Vegetation fraction is defined as the vertical occupation of
                          vegetation canopy on the ground. Vegetation fraction is defined as
                          following.
          </p>
                        Vegetation Fraction= VI-VI<sub>minimumu</sub> / VI<sub>maximum</sub>{" "}
                        -VI<sub>minimumu</sub> --- (4)
          <p align="justify">
                          The water stress coefficient (Ks) and soil evaporation coefficient
                          (Ke) are derived using soil data from Harmonized World Soil Database
                          (HWSD) and soil moisture products from SMAP and SMOS missions. The
                          soil water characteristics are obtained using texture and organic
                          matter content information which provided with HWSD database (Saxton
            &amp; Rawls, 2006).{" "}
                        </p>
                        The input datasets being utilized in soil water balance model are
                        listed in Table below.
          <p align="justify">
                          The soil water balance model is run at daily for different passes of
                          SMOS over India. The computations of evapotranspiration for
                          different passes are averaged on a given day to generate a single
                          day mosaic. SMOS which has a swath of 900 Km can’t provide surface
                          soil moisture for entire Indian region on a given day; therefore, a
                          3-day average product of evapotranspiration at 15 km spatial
                          resolution is finally generated and disseminated with 3-day latency.
                          As part of this activity, under NHP it is also planned to validate
                          this satellite based estimates across the country. Towards this, it
                          is planned to establish AET measurement instrumentation across the
                          country under diverse agro-climatic zone. Although limited
                          validation of estimated product is carried out with global satellite
                          based AET products and ground observations.
          </p> */}
                        {/* <strong>Reference</strong>
                        <ol>
                          <li>
                            Allan, R. &amp;. (1998). Crop evapotranspiration-Guidelines for
                            computing crop water requirements. FAO Irrigation and drainage
                            paper 56 .
            </li>
                          <li>
                            Pocas, I., Paco, T. A., Perades, P., Cunha, M., &amp; Pereira, L.
                            S. (2015). Estimation of Actual Crop Coefficients Using Remotely
                            Sensed Vegetation Indices and Soil Water Balance Modelled Data.
                            Remote Sensing .
            </li>
                          <li>
                            Saxton, K. E., &amp; Rawls, W. J. (2006). Soil Water
                            Characteristic Estimates by Texture and Organic Matter for
                            Hydrologic Solutions. Soil Science Society of America Journal , 70
                            (5).
            </li>
                        </ol> */}
                        <br />
                        <br />


                      </div>
                    </div>
                    {/* 
<div class="dialog-statusbar">Ready</div> */}
                  </div>
                ) : this.props.disclaimer ? (
                  <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.props.handleDialogClose}
                      ></div>
                      Disclaimer
                    </div>
                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    >
                      <div class="dialog_content" >
                        {" "}
                        <p style={{ textAlign: "justify" }}>
                          Product validation is carried out with limited ground data and other global Actual evapotranspiration (AET) products. NRSC uses several resources to derive and deliver Actual evapotranspiration (AET) through this website. Neither NRSC nor any other party involved in creating, producing or delivering the Actual evapotranspiration (AET) product through this website shall be liable for any direct, incidental, consequential, indirect or punitive damages arising out of Users' access to, or use of, the website and the products. NRSC does not guarantee the accuracy of information provided by external sources and accepts no responsibility or liability for any consequences arising from the use of such data. User feedback on any errors or inaccuracies will be highly appreciated.
                          </p>
                        <br />
                        <br />

                      </div>
                    </div>
                  </div>
                ) : (
                      <div className="sweet-loading">
                        <FadeLoader
                          sizeUnit={"px"}
                          color={"#123abc"}
                          loading={this.state.chartloading}
                        />
                      </div>
                    )}
              </Rnd>
            ) : null}


               
            {this.props.visibleGraphPanel  &&  this.state.showChart? (
              <Draggable disabled={!this.state.isDraggable}>
              <div
                className="chart_et"
                style={{
                  zIndex: "200",
                  background: "white",
                  cursor: this.state.isDraggable ? 'move' : 'default',
                  position: "fixed",
                  left: this.state.x,
                  top: this.state.y,
                  width: this.state.width,
                  height: this.state.height,
                }}
                onMouseDown={this.handleMouseDown}
              >
                {this.props.chartData !== null && this.state.collapsed ? (
                  
                  <Charts
                    {...this.props.chartData}
                    toggleVisibleGraphPanel={this.props.toggleVisibleGraphPanel}
                    isDraggingAllowed={this.state.isDraggingAllowed}
                    setHandleDraggble={this.setHandleDraggble}
                    selected={this.props.selectedMenu}
                   
                    
                  />
                ) : (
                    <div className="sweet-loading">
                      {/* <FadeLoader
                        sizeUnit={"px"}
                        color={"#123abc"}
                        loading={this.props.loading}
                      /> */}
                      <FadeLoader
                      loading={this.props.loading}
                       height={15} width={5} radius={2} margin={2} />

                    </div>
                  )}
                  </div>

              </Draggable>
            ) : null}





            {this.state.visibleGraphPanel1===true && this.state.timeserieschartdata.length>0? (
                <Rnd className="etEchartAnalysis1"
                style={{ zIndex: "200", background: "white" }}
                default={{
                  x: this.props.x,
                  y: this.props.y,
                  width: this.props.width,
                  height: this.props.height,
                }}
                onDragStop={(e, d) => {
                  e.stopPropagation();
                  // this.setState({ x: d.x, y: d.y });
                }}
              >

                {this.state.timeserieschartdata.length>0 ? (
                
                <TimeCharts
                   data={this.state.timeserieschartdata}
                   dates={this.state.timeserieschartdates}
                   title={this.state.titleTimeseries}
                   timestampselected={this.state.timestampselected}
                   timeseries_y_axis={this.state.timeseries_y_axis}

                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel1}
                    isDraggingAllowed={this.state.isDraggingAllowed}
                    setHandleDraggble={this.setHandleDraggble}
                    
                  />
                ) : (
                    
  <div>No data available</div>

                  )}

              </Rnd>
            ) : null}
           

    
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  availableDates: state.ETState.dates,
  monthly_dates: state.ETState.monthly_dates,
  monthly_yrs: state.ETState.monthly_yrs,

  mn_selectedLayer: state.ETState.mn_selectedLayer,
  fn_selectedLayer: state.ETState.fn_selectedLayer,
  fn_selectedFN: state.ETState.fn_selectedFN,

  fortnightly_dates: state.ETState.fortnightly_dates,
  fortnightly_yrs: state.ETState.fortnightly_yrs,
    
  date: state.ETState.date,
  slideTracker: state.ETState.slideTracker,
  latlng: state.ETState.latlng,
  selectedMenu: state.ETState.selectedMenu,
  selectedLayer: state.ETState.selectedLayer,
  legendVisible: state.ETState.legendVisible,
  chartData: state.ETState.chartData,
  showInfo: state.ETState.showInfo,
  visibleGraphPanel: state.ETState.visibleGraphPanel,
  //visibleGraphPanel1: state.ETState.visibleGraphPanel1,
  loading: state.ETState.loading,
  pointInfo: state.ETState.pointInfo,
  x: state.ETState.x,
  y: state.ETState.y,
  width: state.ETState.y,
  height: state.ETState.height,
  selectedNodeStatus: state.ETState.selectedNodeStatus,
  visible: state.ETState.visible,
  legend: state.ETState.legend,
  technicalnote: state.ETState.technicalnote,
  disclaimer: state.ETState.disclaimer,
  EB_popup: state.ETState.EB_popup,
  WB_popup: state.ETState.WB_popup,
  inlinemode: state.ETState.inlinemode
});
export default connect(mapStateToProps, {
  modeChange,
  getETDates,

  setSelectedMNLayer,
  setSelectedFNLayer,
  
  onSlide,
  setSelectedMenu,
  setSelectedLayer,
  onClickSlideLeft,
  onClickSlideRight,
  handleDateChange,
  onMapClick,
  toggleVisibleGraphPanel,
 

  toggleSelectedNodeStatus,
  sidebarToggle,
  setLegend,
  EBPToggle,
  technicalNodeToggle,
  disclaimerToggle,
  handleDialogClose,
  getWidth
})(MapContainer);
